(function () {
	'use strict';

	angular.module('trakeyeApp').controller('LocationLogController', LocationLogController);

	LocationLogController.$inject = ['$filter', '$scope', '$compile', '$state', 'LocationLog', 'ParseLinks', 'AlertService', 'pagingParams', '$stateParams', 'paginationConstants', 'LocationLogMap',
		'LocationLogMapPath', 'LocationLogVehicleMapPath', 'UsersGeoFenceData', 'UserAccount', 'GeofenceIDs', 'UserGeofences', 'AssetDB', 'AssetByID', '$interval', 'Report', 'AssetTypesByGeofenceID', 'VehicleGeoFenceData', 'AssetType', '$rootScope','GeofenceByID','TrCaseForMap','TrCaseById','UserDetails'];

	function LocationLogController($filter, $scope, $compile, $state, LocationLog, ParseLinks, AlertService, pagingParams, $stateParams, paginationConstants, LocationLogMap, LocationLogMapPath, LocationLogVehicleMapPath,
		UsersGeoFenceData, UserAccount, GeofenceIDs, UserGeofences, AssetDB, AssetByID, $interval, Report, AssetTypesByGeofenceID, VehicleGeoFenceData, AssetType, $rootScope,GeofenceByID,TrCaseForMap,TrCaseById,UserDetails) {
		var vm = this;

		vm.loadPage = loadPage;
		vm.predicate = pagingParams.predicate;
		vm.reverse = pagingParams.ascending;
		vm.transition = transition;
		vm.itemsPerPage = paginationConstants.itemsPerPage;
		vm.drawUserPath = drawUserPath;
		vm.type = "user";
		vm.pathuserid = null;
		vm.logsbystatus = [];
		vm.all = all;
		vm.active = active;
		vm.inactive = inactive;
		vm.idle = idle;
		vm.absent = absent;
		vm.filterUsers = filterUsers;
		vm.fromDate = null;
		vm.toDate = null;
		vm.today = today;
		vm.today();
		vm.onChangeDate = onChangeDate;
		var openedInfoWindow = null;
		var latlng;
		vm.datePickerOpenStatus = {};
		vm.openCalendar = openCalendar;
		var dateFormat = 'yyyy-MM-dd';
		vm.selectedLogs = "ALL";
		var markerUserName = "";
		$scope.alllength;
		$scope.activelength;
		$scope.inactivelength;
		$scope.idlelength;
		vm.vehicles = [];
		vm.polygon = [];

		vm.allGeofences = [];
		vm.selectedGeofenceId = null;
		vm.prevSelectedGeofenceId = null;
		var prevInfoWindow = null;

		vm.userGeofences = [];
		vm.assetFilterGeofences = [];
		vm.selectedUserGeofenceId = null;
		vm.prevSelectedUserGeofenceId = null;
		vm.responseLiveLogs = null

		vm.filterAssetsLocationOnMapView = filterAssetsLocationOnMapView;
		vm.closeMapLocationFilterModal = closeMapLocationFilterModal;
		vm.filterAssetsLoadOnMapView = filterAssetsLoadOnMapView;
		vm.closeMapLoadPathFilterModal = closeMapLoadPathFilterModal;
		vm.saveLocationFilter = saveLocationFilter;
		vm.saveLoadPathFilter = saveLoadPathFilter;

		vm.downloadLoadPath = downloadLoadPath;

		var markers = [];
		var polylines = [];

		var markersForPath = [];
		var polylinesForPath = [];

		var noDataText = null;
		vm.mapAssets = [];
		var userPathId = null;
		var userIdSelected = null;

		vm.assetTypeValues = [];

		vm.assetTypeValuesPath = [];

		vm.selecterange = selectRange;
		vm.customRange = customRange;

		$scope.tab = 1;
		$scope.geofencelabel = {
			search: "Search",
			nothingSelected: "Block"
		}
		$scope.setTab = function (newTab) {
			$scope.tab = newTab;
			if ($scope.tab == 1) {
				//filterAssetsLocationOnMapView()
			} else if ($scope.tab == 2) {
				vm.locateUsers;
			}
		};
		$scope.isSet = function (tabNum) {
			return $scope.tab === tabNum;
		};
		$(".select2").select2();
		$scope.geofenceMapview = function () {
			vm.selectedGeofenceId = vm.selectedGeofence[0].id
			vm.displayGeofenceCases(vm.selectedGeofenceId)
			saveLocationFilter()
		}

		$scope.geofenceTravelledPath = function () {
          
			if (!vm.selectedUserGeofenceId) {
				console.log("No geofence selected");
				return;
			}

			saveLoadPathFilter();
			vm.displayGeofenceCasesInLOadTravel(vm.selectedUserGeofenceId);
		};

		$("#searchOnMap").change(function () {
			var vehicleSelected = JSON.parse($("#searchOnMap").val());
			var vehicleLatLng = ({
				lat: vehicleSelected.latitude,
				lng: vehicleSelected.longitude
			});
			locations.map.setCenter(vehicleLatLng);
			locations.map.setZoom(20);
		});

		function myOption(zoom, center) {
			var myOptions;
			return (myOptions = {
				zoom: zoom,
				center: center,
				scaleControl: true,
				mapTypeId: google.maps.MapTypeId.ROADMAP,
				styles: [
					{
						featureType: "poi",
						elementType: "labels.icon",
						stylers: [
							{
								color: "#63666A",
							},
						],
					},
					{
						elementType: "labels.text.fill",
						stylers: [
							{
								color: "#63666A",
							},
						],
					} /* 
                    {
                        elementType: "geometry.fill",
                        stylers: [
                            {
                                color: "#EFEFEF",
                            },
                        ],
                    }, */,
					{
						featureType: "transit",
						elementType: "labels.icon",
						stylers: [
							{
								color: "#63666A",
							},
						],
					},
					{
						featureType: "road",
						elementType: "labels.icon",
						stylers: [{ visibility: "off" }],
					},
					{
						featureType: "landscape",
						stylers: [
							{
								color: "#efefef",
							},
						],
					},
					{
						featureType: "road.highway",
						elementType: "geometry",
						stylers: [
							{
								color: "#ffffff",
							},
						],
					}
				],
			});
		}

		function geoLocation(map) {
			var infoWindow = new google.maps.InfoWindow();
			var locationButton = document.createElement("button");
			locationButton.setAttribute("title", "Locate Me");
			locationButton.classList.add("custom-map-control-button");
			var geoIcon = document.createElement("i");
			geoIcon.classList.add("fa");
			geoIcon.classList.add("fa-crosshairs");
			geoIcon.classList.add("geo");
			locationButton.appendChild(geoIcon)
			map.controls[google.maps.ControlPosition.TOP_RIGHT].push(
				locationButton
			);

			/* locationButton.addEventListener("click", function () {
				// Try HTML5 geolocation.
				if (navigator.geolocation) {
					navigator.geolocation.getCurrentPosition(
						function (position) {
							var pos = {
								lat: position.coords.latitude,
								lng: position.coords.longitude,
							};
							infoWindow.setPosition(pos);
							infoWindow.setContent("Location found.");	
							infoWindow.open(map);
							map.setCenter(pos);
							map.setZoom(18);
						},
						function () {
							handleLocationError(
								true,
								infoWindow,
								map.getCenter()
							);
						},
						{ enableHighAccuracy: true,
							timeout: 5000,
							maximumAge: 0}
					);
				} else {
					// Browser doesn't support Geolocation
					handleLocationError(
						false,
						infoWindow,
						map.getCenter()
					);
				}
			}); */

			/* function handleLocationError(
				browserHasGeolocation,
				infoWindow,
				pos
			) {
				infoWindow.setPosition(pos);
				infoWindow.setContent(
					browserHasGeolocation
						? "Error: The Geolocation service failed."
						: "Error: Your browser doesn't support geolocation."
				);
				infoWindow.open(map);
			} */
		}

		if ($scope.tab == 1) {
			UserAccount.get(function (data) {
				var isAdmin = false;
				data.authorities.forEach(function (val) {
					if (val == "ROLE_USER_ADMIN") {
						isAdmin = true;
					} else if (val == "ROLE_HOD") {
						isAdmin = true;
					}
				});
				if (isAdmin) {
					vm.adminFilter = true;
					filterUsers();
					vm.updateUsers();
					vm.locateUsers;
					filterAssetsLocationOnMapView()
				} else {
					vm.adminFilter = false;
					filterUsers();
					vm.updateUsers();
					vm.locateUsers;
					filterAssetsLocationOnMapView()
				}
				AssetType.query(
					{
						page: 0,
						size: 100,
						sort: sort(),
					},
					onSuccess,
					onError
				);
				function sort() {
					var result = [
						vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
					];
					if (vm.predicate !== "id") {
						//  result.push('id');
					}
					return result;
				}
				function onSuccess(data, headers) {
					vm.assetTypes = data;
				}
				function onError(error) {
					AlertService.error(error.data.message);
				}
			});
		}

		function getGroupAssetsFromES(geofenceIdVal, lastAssetId, mapAssetLists) {
			AssetDB.get(geofenceIdVal, lastAssetId, function (data) {
				vm.mapAssets = mapAssetLists;
				data.assets.forEach(function (asset) {
					var tmpAsset = {};

					tmpAsset.assetCoordinates = asset.assetCoordinates;
					tmpAsset.assetTypeName = asset.assetTypeName;
					tmpAsset.assetTypeColor = asset.assetColor;
					tmpAsset.assetTypeImagePath = asset.assetTypeImagePath;
					tmpAsset.assetTypeLayout = asset.assetTypeLayout;
					tmpAsset.id = asset.id;
					tmpAsset.name = asset.name;

					vm.mapAssets.push(tmpAsset);
				});


				if (data.assets.length < 200) {
					clearMarkers(markers);
					clearPolylines(polylines);

					for (var index = 0; index < vm.assetTypeValues.length; index++) {
						var assetType = vm.assetTypeValues[index];
						var typeName = assetType.assetTypeName;
						var typeAssetsList = [];
						if (assetType.assets != null) {
							typeAssetsList = assetType.assets;
						}

						vm.mapAssets.forEach(function (asset) {
							if (typeName == asset.assetTypeName) {
								typeAssetsList.push(asset);
							}
						});
						assetType.assets = typeAssetsList;
						vm.assetTypeValues[index] = assetType;
					}
					var assetList = [];
					for (var index = 0; index < vm.assetTypeValues.length; index++) {
						vm.assetTypeValues[index].assets.forEach(function (assetVal) {
							assetList.push(assetVal);
						});
					}
					drawAssets(assetList);
					// if (vm.selectedLogs === "ALL") {
					// 	vm.all();
					// } else if (vm.selectedLogs === "ACTIVE") {
					// 	vm.active();
					// } else if (vm.selectedLogs === "INACTIVE") {
					// 	vm.inactive();
					// } else if (vm.selectedLogs === "IDLE") {
					// 	vm.idle();
					// }
				}
				if (data.lastId != null) {
					getGroupAssetsFromES(geofenceIdVal, data.lastId, vm.mapAssets);
				} else {
					if (vm.mapAssets.length > 0) {
						var assetSelected = vm.mapAssets[0];
						var centerlatlng = {
							lat: assetSelected.assetCoordinates[0].latitude,
							lng: assetSelected.assetCoordinates[0].longitude
						};
						try {
							locations.map.setCenter(centerlatlng);
							locations.map.setZoom(10);
						} catch (err) {
							console.log(err);
						}
					}
				}
			});
		}

		function getGroupAssetsFromDBPath(geofenceIdVal, lastAssetId, mapAssetLists) {
			AssetDB.get(geofenceIdVal, lastAssetId, function (data) {
				vm.mapUserAssets = mapAssetLists;
				data.assets.forEach(function (asset) {
					var tmpAsset = {};

					tmpAsset.assetCoordinates = asset.assetCoordinates;
					tmpAsset.assetTypeName = asset.assetTypeName;
					tmpAsset.assetTypeColor = asset.assetColor;
					tmpAsset.assetTypeImagePath = asset.assetTypeImagePath;
					tmpAsset.assetTypeLayout = asset.assetTypeLayout;
					tmpAsset.id = asset.id;
					tmpAsset.name = asset.name;
					vm.mapUserAssets.push(tmpAsset);
				});


				if (data.assets.length < 200) {
					clearMarkers(markersForPath);
					clearPolylines(polylinesForPath);

					for (var index = 0; index < vm.assetTypeValuesPath.length; index++) {
						var assetType = vm.assetTypeValuesPath[index];
						var typeName = assetType.assetTypeName;
						var typeAssetsList = [];
						if (assetType.assets != null) {
							typeAssetsList = assetType.assets;
						}

						vm.mapUserAssets.forEach(function (asset) {
							if (typeName == asset.assetTypeName) {
								typeAssetsList.push(asset);
							}
						});
						assetType.assets = typeAssetsList;
						vm.assetTypeValuesPath[index] = assetType;
					}
					var assetList = [];
					for (var index = 0; index < vm.assetTypeValuesPath.length; index++) {
						vm.assetTypeValuesPath[index].assets.forEach(function (assetVal) {
							assetList.push(assetVal);
						});
					}
					drawAssetsForPath(assetList);

					vm.assetFilterGeofences.forEach(function(value){
						var coordinatesList = JSON.parse(value.coordinates);
						coordinatesList.push(coordinatesList[0]);
						
						if(value.id==vm.selectedUserGeofenceId){
							drawPolylineForGeoFence(coordinatesList, userPaths.map, "green", value.name,null);
						} else {
							drawPolylineForGeoFence(coordinatesList, userPaths.map, "blue", value.name,null);
						}
					});
				}
				if (data.lastId != null) {
					getGroupAssetsFromDBPath(geofenceIdVal, data.lastId, vm.mapUserAssets);
				} else {
					if (vm.mapUserAssets.length > 0) {
						var assetSelected = vm.mapUserAssets[0];
						var centerlatlng = {
							lat: assetSelected.assetCoordinates[0].latitude,
							lng: assetSelected.assetCoordinates[0].longitude
						};
						try {
							userPaths.map.setCenter(centerlatlng);
							userPaths.map.setZoom(10);
						} catch (err) {
							console.log(err);
						}
					}
				}
			});
		}

		vm.updateUsers = function () {
			vm.locateUsers(function () {
				if (vm.selectedLogs === "ALL") {
					vm.all();
				} else if (vm.selectedLogs === "ACTIVE") {
					vm.active();
				} else if (vm.selectedLogs === "INACTIVE") {
					vm.inactive();
				} else if (vm.selectedLogs === "IDLE") {
					vm.idle();
				} else if (vm.selectedLogs === "ABSENT"){
					vm.absent();
				}
			});
		}
		var updateLogs = function () {

			vm.updateUsers();
			vm.locateUsers;
		}

		var userPaths = {};
		var locations = {};

		function onChangeDate() {
			if (vm.fromDate && vm.toDate) {
				vm.toDate.setHours(23, 59, 59, 999);
				if (vm.fromDate <= vm.toDate) {
					vm.drawUserPath(vm.pathuserid, vm.type);
					userIdSelected = vm.pathuserid;
				} else {
					alert('Selected "From Date" is greater than "To Date" : Please Select Proper Date')
				}
			}
		}

		function customRange() {
			vm.fromDate = null
			vm.toDate = null
			vm.totalDistance = 0;
			$scope.totalDistanceTravelled = "0 kms";
			vm.inProgressDistance = 0
			userPaths.map = new google.maps.Map(document.getElementById("userPath_map_canvas"), myOption(13, userPaths.latlng));
		}
		function today() {
			var today = new Date();
			vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1);
			vm.fromDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1);
		}
		var date = new Date();

		$scope.options = {
			maxDate: date.setDate(date.getDate())
		};
		function selectRange() {
			selectRangePresent()
			vm.drawUserPath(vm.pathuserid, vm.type);
			userIdSelected = vm.pathuserid;
		}
		function selectRangePresent() {
			var today = new Date();
			vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
			vm.fromDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
			vm.fromDate.setHours(0, 0, 0, 0);
			vm.fromTime = vm.fromDate.getTime();
			vm.toDate.setHours(23, 59, 59, 999);
			vm.toTime = vm.toDate.getTime();
		}

		function loadPage(page) {
			vm.page = page;
			vm.transition();
		}

		function transition() {
			$state.transitionTo($state.$current, {
				page: vm.page,
				sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
				search: vm.currentSearch
			});
		}

		$scope.$watch('login', function (searchkey, oldval) {
			if (searchkey || oldval)
				drawLatestlocations($filter('filter')($scope.locations, {
					userName: searchkey
				}));
		})

		$scope.openInfoWindow = function (e, selectedMarker) {
			e.preventDefault();
			google.maps.event.trigger(selectedMarker, 'click');
		}

		function drawUserPath(userId) {
			var data = {
				fromDate: vm.fromDate.getTime(),
				toDate: vm.toDate.getTime(),
				userId: userId
			}
			if (vm.type == "user") {
				LocationLogMapPath.getmaplogs(data, function (response) {
					vm.pathuserid = response.id;
					drawlines(response);
				});
			} else {
				LocationLogVehicleMapPath.getmaplogs(data, function (response) {
					vm.pathuserid = response.id;
					drawlines(response);
				});
			}
		}

		vm.locateUsers = function (callback) {
			LocationLogMapPath.locateUsers(function (response) {
				vm.responseLiveLogs = response.liveLogs
				$scope.trCases = response.trCases;
				$scope.locations = response.liveLogs;
				vm.vehicles = response.vehicleLocationList;
				$scope.offDutyUserlocations = response.inactiveUserLogs;
				callback();
			});
		}

		function filterUsers() {
			var isTrue
			if (vm.responseLiveLogs && vm.searchUser) {
				isTrue = vm.responseLiveLogs.find(function (item) {
					return item.login == vm.searchUser
				})
			}

			if (vm.searchUser && !isTrue) {
				LocationLogMapPath.locateUsersLogin(
					vm.searchUser,
					function (response) {

						if (!response || !response.length) {
							alert('User not found');
							return;
						}

						var updatedResponse = [{
							"latitude": response[0].latitude,
							"longitude": response[0].longitude,
							"login": response[0].login,
							"userid": response[0].userId
						}];

						callSelectedLogs(updatedResponse);
					},
					function () {
						alert('User has not traveled today.');
					}
				);
			}


			callSelectedLogs($scope.locations)

		}
		vm.filteredUsers = [];
		vm.showSuggestions = false;

		vm.onUserSearchChange = function () {
			if (!vm.searchUser || vm.searchUser.length < 3) {
				vm.filteredUsers = [];
				vm.showSuggestions = false;
				return;
			}
			var keyword = vm.searchUser.toLowerCase();
			vm.filteredUsers = [];
			for (var i = 0; i < vm.responseLiveLogs.length; i++) {
				var login = vm.responseLiveLogs[i].login.toLowerCase();

				if (login.indexOf(keyword) !== -1) {
					vm.filteredUsers.push(vm.responseLiveLogs[i]);
				}
			}
			vm.showSuggestions = vm.filteredUsers.length > 0;
		};

		vm.selectUser = function (user) {
			vm.searchUser = user.login;
			vm.showSuggestions = false;
			filterUsers();   
		};

		function callSelectedLogs(param) {
			if (vm.selectedLogs === "ALL") {

				drawLatestlocations($filter('filter')(param, {
					'login': vm.searchUser
				}));


			} else {
				$scope.alllength = ($filter('filter')($filter('filter')(param, {
					'status': vm.selectedLogs
				}, true), {
					'login': vm.searchUser
				})).length;
				drawLatestlocations($filter('filter')($filter('filter')(param, {
					'status': vm.selectedLogs
				}, true), {
					'login': vm.searchUser
				}));
			}
		}

		function all() {
			vm.selectedLogs = "ALL";
			if ($stateParams.login == undefined) {
				try {
					$scope.alllength = ($filter('filter')($scope.locations, {
						'login': $stateParams.login
					})).length;
					$scope.activelength = ($filter('filter')($filter('filter')($scope.locations, {
						'status': "ACTIVE"
					}, true), {
						'login': vm.searchUser
					})).length;
					$scope.inactivelength = ($filter('filter')($filter('filter')($scope.locations, {
						'status': "INACTIVE"
					}, true), {
						'login': vm.searchUser
					})).length;
					$scope.idlelength = ($filter('filter')($filter('filter')($scope.locations, {
						'status': "IDLE"
					}, true), {
						'login': vm.searchUser
					})).length;
					$scope.absentlength = ($filter('filter')($filter('filter')($scope.locations, {
						'status': "ABSENT"
					}, true), {
						'login': vm.searchUser
					})).length;
				} catch (err) {
					console.log(err);
				}
				drawLatestlocations($filter('filter')($scope.locations, {
					'login': vm.searchUser
				}));
			} else {
				try {
					$scope.alllength = ($filter('filter')($scope.locations, {
						'login': $stateParams.login
					})).length;
					$scope.activelength = ($filter('filter')($filter('filter')($scope.locations, {
						'status': "ACTIVE"
					}, true), {
						'login': vm.searchUser
					})).length;
					$scope.inactivelength = ($filter('filter')($filter('filter')($scope.locations, {
						'status': "INACTIVE"
					}, true), {
						'login': vm.searchUser
					})).length;
					$scope.idlelength = ($filter('filter')($filter('filter')($scope.locations, {
						'status': "IDLE"
					}, true), {
						'login': vm.searchUser
					})).length;
					$scope.absentlength = ($filter('filter')($filter('filter')($scope.locations, {
						'status': "ABSENT"
					}, true), {
						'login': vm.searchUser
					})).length;
				} catch (err) {
					console.log(err);
				}
				drawLatestlocations($filter('filter')($scope.locations, {
					'login': $stateParams.login
				}));
			}

		}
		function active() {
			vm.selectedLogs = "ACTIVE";
			$scope.activelength = ($filter('filter')($filter('filter')($scope.locations, {
				'status': vm.selectedLogs
			}, true), {
				'login': vm.searchUser
			})).length;
			$scope.alllength = ($filter('filter')($scope.locations, {
				'login': $stateParams.login
			})).length;
			$scope.inactivelength = ($filter('filter')($filter('filter')($scope.locations, {
				'status': "INACTIVE"
			}, true), {
				'login': vm.searchUser
			})).length;
			$scope.idlelength = ($filter('filter')($filter('filter')($scope.locations, {
				'status': "IDLE"
			}, true), {
				'login': vm.searchUser
			})).length;
			$scope.absentlength = ($filter('filter')($filter('filter')($scope.locations, {
				'status': "ABSENT"
			}, true), {
				'login': vm.searchUser
			})).length;

			drawLatestlocations($filter('filter')($filter('filter')($scope.locations, {
				'status': vm.selectedLogs
			}, true), {
				'login': vm.searchUser
			}));

		}

		function inactive() {
			vm.selectedLogs = "INACTIVE";
			$scope.inactivelength = ($filter('filter')($filter('filter')($scope.locations, {
				'status': vm.selectedLogs
			}, true), {
				'login': vm.searchUser
			})).length;
			$scope.alllength = ($filter('filter')($scope.locations, {
				'login': $stateParams.login
			})).length;
			$scope.activelength = ($filter('filter')($filter('filter')($scope.locations, {
				'status': "ACTIVE"
			}, true), {
				'login': vm.searchUser
			})).length;
			$scope.idlelength = ($filter('filter')($filter('filter')($scope.locations, {
				'status': "IDLE"
			}, true), {
				'login': vm.searchUser
			})).length;
			drawLatestlocations($filter('filter')($filter('filter')($scope.locations, {
				'status': vm.selectedLogs
			}, true), {
				'login': vm.searchUser
			}));

		}

		function idle() {
			vm.selectedLogs = "IDLE";
			$scope.idlelength = ($filter('filter')($filter('filter')($scope.locations, {
				'status': vm.selectedLogs
			}, true), {
				'login': vm.searchUser
			})).length;
			$scope.alllength = ($filter('filter')($scope.locations, {
				'login': $stateParams.login
			})).length;
			$scope.activelength = ($filter('filter')($filter('filter')($scope.locations, {
				'status': "ACTIVE"
			}, true), {
				'login': vm.searchUser
			})).length;
			$scope.inactivelength = ($filter('filter')($filter('filter')($scope.locations, {
				'status': "INACTIVE"
			}, true), {
				'login': vm.searchUser
			})).length;
			$scope.absentlength = ($filter('filter')($filter('filter')($scope.locations, {
				'status': "ABSENT"
			}, true), {
				'login': vm.searchUser
			})).length;

			drawLatestlocations($filter('filter')($filter('filter')($scope.locations, {
				'status': vm.selectedLogs
			}, true), {
				'login': vm.searchUser
			}));

		}

		function absent() {
			vm.selectedLogs = "ABSENT";
			$scope.absentlength = ($filter('filter')($filter('filter')($scope.locations, {
				'status': vm.selectedLogs
			}, true), {
				'login': vm.searchUser
			})).length;
			$scope.idlelength = ($filter('filter')($filter('filter')($scope.locations, {
				'status': "IDLE"
			}, true), {
				'login': vm.searchUser
			})).length;
			$scope.alllength = ($filter('filter')($scope.locations, {
				'login': $stateParams.login
			})).length;
			$scope.activelength = ($filter('filter')($filter('filter')($scope.locations, {
				'status': "ACTIVE"
			}, true), {
				'login': vm.searchUser
			})).length;
			$scope.inactivelength = ($filter('filter')($filter('filter')($scope.locations, {
				'status': "INACTIVE"
			}, true), {
				'login': vm.searchUser
			})).length;

			drawLatestlocations($filter('filter')($filter('filter')($scope.locations, {
				'status': vm.selectedLogs
			}, true), {
				'login': vm.searchUser
			}));

		}

		function drawLatestVehicles(vehicles) {
			if(vehicles!=undefined){
			vehicles.forEach(function (vehicle) {
				var activeInfoWindow;
				var startMarker = new google.maps.Marker({
					map: locations.map,
					position: new google.maps.LatLng(vehicle.latitude, vehicle.longitude),
					title: vehicle.licenseplate,
					icon: {
						scaledSize: new google.maps.Size(
							32, 32),
						url: 'content/images/car.png',
						anchor: new google.maps.Point(
							(32 / 2) + 16, (32 / 2) + 16),
					}
				});
				var infoWindow = new google.maps.InfoWindow();

				var userContent = document.createElement('div'),
					button;
				userContent.innerHTML = '<div>' +
					'<b>Vehicle Id&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; : </b>&nbsp;' + vehicle.vehicleid + '<br>' +
					'<b>License Plate&nbsp; : </b>&nbsp;' + vehicle.licenseplate + '<br>' +
					'<b>GPS IMEI&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; : </b>&nbsp;' + vehicle.gpsimei + '<br>' +
					'<b>Vehicle Type&nbsp;&nbsp; : </b>&nbsp;' + vehicle.vehicletype + '</div>';

				button = userContent.appendChild(document.createElement('input'));
				button.type = 'button';
				button.value = 'Load travelled path';
				button.className = "button";
				google.maps.event.addDomListener(button, 'click', function () {
					vm.dateRange = null
					vm.dateRange = 'day'
					selectRangePresent()
					vm.type = "vehicle";
					markerUserName = vehicle.licenseplate;
					userPath(vehicle.vehicleid);
				})
				var infowindowPopup = new google.maps.InfoWindow({
					content: userContent,
					pixelOffset: new google.maps.Size(0, -50),
				});
				google.maps.event.addDomListener(startMarker, 'click', function (event) {
					infowindowPopup.setPosition(new google.maps.LatLng(vehicle.latitude, vehicle.longitude));
					infowindowPopup.open(locations.map);

					if (activeInfoWindow != null)
						activeInfoWindow.close();
					activeInfoWindow = infowindowPopup;

				});

				google.maps.event.addDomListener(startMarker, "click", function (event) {
					google.maps.event.trigger(self, "click");

					infowindowPopup.open(locations.map);
				});
				function userPath(id) {
					vm.userGeofences = [];
					vm.assetFilterGeofences = [];
					vm.selectedUserGeofenceId = null;
					vm.prevSelectedUserGeofenceId = null;
					var ele = document.getElementById("userPathModal");
					$(ele).modal('show');
					vm.drawUserPath(id);
					userIdSelected = id;
				}
			});
		}
		}
        var userMarkersMap = {}; // userid → customMarker
		function drawLatestlocations(response) {
			var markers = [{
				Lat: "0.0",
				Lng: "0.0",
				name: "default"
			}];

			if (response) {
				var activeInfoWindow;
				initializeMap(
					response,
					function (latlang) {
						locations.latlng = latlang;
						var bounds = new google.maps.LatLngBounds();

						setupUsersMap(function () {
							response.sort(function(a, b) {
								return a.createdDateTime - b.createdDateTime;
							});
							$.each(response, function (index, value) {
								
								if (!(vm.selectedLogs === "ALL" && value.status === "ABSENT") && value.latitude != null && value.longitude != null &&
									!isNaN(value.latitude) && !isNaN(value.longitude) &&
									Number(value.latitude) > 0 &&
									Number(value.longitude) > 0) {
									var infoWindow = new google.maps.InfoWindow();

									var infoWindow2 = new google.maps.InfoWindow();

									// Create a custom marker

									var imgbg = document.createElement('img');
									imgbg.className = "marker_back_image";

									if (value.reportingStatus == true) {
										if (value.status === 'ABSENT') {
											imgbg.src = 'content/images/Absent_user.png';
										} else if (value.userRole === 'ROLE_FRT') {
											if (value.status === 'ACTIVE') {
												imgbg.src = 'content/images/frt_active.png';
											} else if (value.status === 'INACTIVE') {
												imgbg.src = 'content/images/frt_inactive.png';
											} else if (value.status === 'IDLE') {
												imgbg.src = 'content/images/frt_idle.png';
											}
										} else {
											if (value.status == 'ACTIVE') {
												if (value.geoStatus == 'IN') {
													if (value.userRole == 'ROLE_PATROLLER') {
														imgbg.src = 'content/images/pat_active_in.png';
													} else {
														imgbg.src = 'content/images/active_in.png';
													}

												} else {
													if (value.userRole == 'ROLE_PATROLLER') {
														imgbg.src = 'content/images/pat_active_out.png';
													} else {
														imgbg.src = 'content/images/active_out.png';
													}
												}
											} else if (value.status == 'INACTIVE') {
												if (value.geoStatus == 'IN') {
													if (value.userRole == 'ROLE_PATROLLER') {
														imgbg.src = 'content/images/pat_inactive_out.png';
													} else {
														imgbg.src = 'content/images/inactive_in.png';
													}
												} else {
													if (value.userRole == 'ROLE_PATROLLER') {
														imgbg.src = 'content/images/pat_inactive_out.png';
													} else {
														imgbg.src = 'content/images/inactive_out.png';
													}
												}
											} else if (value.status == 'IDLE') {
												if (value.geoStatus == 'IN') {
													if (value.userRole == 'ROLE_PATROLLER') {
														imgbg.src = 'content/images/pat_idle_in.png';
													} else {
														imgbg.src = 'content/images/idle_in.png';
													}
												} else {
													if (value.userRole == 'ROLE_PATROLLER') {
														imgbg.src = 'content/images/pat_idle_out.png';
													} else {
														imgbg.src = 'content/images/idle_out.png';
													}
												}
											} else if (value.status == 'Off duty user') {
												if (value.geoStatus == 'IN') {
													if (value.userRole == 'ROLE_PATROLLER') {
														imgbg.src = 'content/images/pat_off_duty_in.png';
													} else {
														imgbg.src = 'content/images/off_duty_in.png';
													}
												} else {
													if (value.userRole == 'ROLE_PATROLLER') {
														imgbg.src = 'content/images/pat_off_duty_out.png';
													} else {
														imgbg.src = 'content/images/off_duty_out.png';
													}
												}
											}
										}
									} else {
										if (value.status === 'ABSENT') {
											imgbg.src = 'content/images/Absent_user.png';
										} else if (value.geoStatus == 'IN') {
											if (value.userRole == 'ROLE_PATROLLER') {
												imgbg.src = 'content/images/pat_caseactive_in.png';
											} else {
												imgbg.src = 'content/images/case_active_in.png';
											}
											if (value.userRole == 'ROLE_FRT') {
												imgbg.src = 'content/images/Inactive_FRT.png'
											}
										} else {
											if (value.userRole == 'ROLE_PATROLLER') {
												imgbg.src = 'content/images/pat_caseactive_out.png';
											} else {
												imgbg.src = 'content/images/case_active_out.png';
											}
											if (value.userRole == 'ROLE_FRT') {
												imgbg.src = 'content/images/Inactive_FRT.png'
											}
										}

									}

									if (value.address == 'SOS') {
										imgbg.src = 'content/images/alert.png'
									}

									if ($scope.trCases != undefined && $scope.trCases.length > 0) {

										$.each($scope.trCases, function (index, value) {

											var infoWindow = new google.maps.InfoWindow();
											var startMarker = new google.maps.Marker({
												map: locations.map,
												position: new google.maps.LatLng(value.pinLat, value.pinLong),
												title: value.description,

											});
											var infoWindow2 = new google.maps.InfoWindow();
											if (value.priority == 'LOW') {
												startMarker.setIcon('content/images/Pointers-L4.png');
											} else if (value.priority == 'MEDIUM') {

												startMarker.setIcon('content/images/Pointers-M4.png');
											} else if (value.priority == 'HIGH') {
												startMarker.setIcon('content/images/Pointers-H4.png');
											} else if (value.priority == 'CRITICAL') {
												startMarker.setIcon('content/images/Pointer-C4.png');
											}
											var span = '<a userId="' + value.geofenceName + '" class="userpath" >Load travelled path</a>';
											startMarker.content = '<div class="infoWindowContent"><b>Incident Id : </b>' + value.id + '<br> <b>Reported By :</b> ' + value.reportedByUser
												+ '<br> <b> Assigned To :</b> ' + value.assignedToUser + '<br> <b>Address :</b> ' + value.address + '</div>';

											$compile(startMarker.content)($scope);

											google.maps.event.addListener(startMarker, 'mouseover', function () {
												infoWindow.setContent('<div class="infoWindowhead">' + startMarker.title + '</div>' + startMarker.content);
												infoWindow.open(locations.map, startMarker);
											});
											// on mouseout
											google.maps.event.addListener(startMarker, 'mouseout', function () {
												infoWindow.close();
											});

											var activeInfoWindow;
											// add content to
											// InfoWindow for
											// click event
											infoWindow2.setContent('<div class="infoWindowhead">' + startMarker.title + '</div>' + startMarker.content);
										})
									}

									function customMarker() {
										this.latlng = new google.maps.LatLng(value.latitude, value.longitude);
										this.setMap(locations.map);
										this.status = value.status;
										this.title = value.login;
										this.icon = imgbg;
									}

									bounds.extend(new google.maps.LatLng(value.latitude, value.longitude));

									var userContent = document.createElement('div'),
										button;

									google.maps.event.addDomListener(imgbg, 'click', function () {
										if (value.userImage != null) {
											UserDetails.getUserDetails(value.login, function (userResp) {
												var firstName = userResp.firstName || '';
												var lastName = userResp.lastName || '';
												var phone = value.phone || 'NA';
												var masterGeofence = userResp.masterGeofences
												var miniGeofence = userResp.miniGeofences
												var reportingTo = userResp.reportingTo
												var distanceTravelled = userResp.distanceTravelled
												var address = value.address || 'NA';
												var selfieImg = userResp.selfyImage;
												var imageSrc = 'content/images/userimg.gif';
												var createdDateTime = formatIST(value.createdDateTime);

												if (selfieImg) {
													imageSrc = 'data:image/jpeg;base64,' + selfieImg;
												}
												userContent.innerHTML =
													'<div class="infoWindowhead" style="position:relative;">' + value.login + '</div>' +
													'<div class="infoWindowContent"style="width:400px;">' +
													'<div style="text-align:center;margin-bottom:6px;">' +
													'<img src="' + imageSrc + '" style="width:80px;height:80px;border-radius:50%;border:2px solid #ccc;" />' +
													'</div>' +
													'<p><b>Name</b> : ' + firstName + ' ' + lastName + '</p>' +
													'<p><b>Phone</b> : ' + phone + '</p>' +
													'<p><b>District</b> : ' + masterGeofence + '</p>' +
													'<p><b>Block</b> : ' + miniGeofence + '</p>' +
													'<p><b>Reporting To</b> : ' + reportingTo + '</p>' +
													'<p><b>Distance Travelled</b> : ' + distanceTravelled + "km" + '</p>' +
													'<p><b>Address</b> : ' + address + '</p>' +
													'<p><b>Captured On :</b> ' + createdDateTime + '</p>' +
													'</div>'

												var button = document.createElement('input');
												button.type = 'button';
												button.value = 'Load travelled path';
												button.className = 'button';
												button.style.position = 'absolute';
												button.style.right = '6px';
												button.style.top = '4px';
												button.style.fontSize = '14px';
												button.style.textDecoration = 'none';

												var header = userContent.querySelector('.infoWindowhead');
												header.appendChild(button);

												// userContent.appendChild(button);

												google.maps.event.addDomListener(button, 'click', function () {
													markerUserName = value.login;
													vm.userPhoneNumber = value.phone
													userPath(value.userid);
												})
											})
										} else {

											UserDetails.getUserDetails(value.login, function (userResp) {

												var firstName = userResp.firstName || '';
												var lastName = userResp.lastName || '';
												var phone = value.phone || 'NA';
												var masterGeofence = userResp.masterGeofences
												var miniGeofence = userResp.miniGeofences
												var reportingTo = userResp.reportingTo
												var distanceTravelled = userResp.distanceTravelled
												var address = value.address || 'NA';

												var selfieImg = userResp.selfyImage;

												var imageSrc = 'content/images/userimg.gif';

												var createdDateTime = formatIST(value.createdDateTime);

												if (selfieImg) {
													imageSrc = 'data:image/jpeg;base64,' + selfieImg;
												}

												userContent.innerHTML =
													'<div class="infoWindowhead" style="position:relative;">' + value.login + '</div>' +
													'<div class="infoWindowContent"style="width:400px;">' +
													'<div style="text-align:center;margin-bottom:6px;">' +
													'<img src="' + imageSrc + '" style="width:80px;height:80px;border-radius:50%;border:2px solid #ccc;" />' +
													'</div>' +
													'<p><b>Name</b> : ' + firstName + ' ' + lastName + '</p>' +
													'<p><b>Phone</b> : ' + phone + '</p>' +
													'<p><b>District</b> : ' + masterGeofence + '</p>' +
													'<p><b>Block</b> : ' + miniGeofence + '</p>' +
													'<p><b>Reporting To</b> : ' + reportingTo + '</p>' +
													'<p><b>Distance Travelled</b> : ' + distanceTravelled + "km" + '</p>' +
													'<p><b>Address</b> : ' + address + '</p>' +
													'<p><b>Captured On :</b> ' + createdDateTime + '</p>' +
													'</div>'

												var button = document.createElement('input');
												button.type = 'button';
												button.value = 'Load travelled path';
												button.className = 'button';
												button.style.position = 'absolute';
												button.style.right = '6px';
												button.style.top = '4px';
												button.style.fontSize = '14px';
												button.style.textDecoration = 'none';
												var header = userContent.querySelector('.infoWindowhead');
												header.appendChild(button);

												google.maps.event.addDomListener(button, 'click', function () {
													vm.dateRange = 'day';
													vm.userPhoneNumber = value.phone;

													selectRangePresent();
													vm.type = 'user';
													markerUserName = value.login;
													userPath(value.userid);
												});
											})
											userPathId = value.userid;
										}
									})

									function formatIST(utcMillis) {
										var date = new Date(utcMillis); // auto converts to IST

										var months = ["Jan","Feb","Mar","Apr","May","Jun",
													"Jul","Aug","Sep","Oct","Nov","Dec"];

										var month = months[date.getMonth()];
										var day = date.getDate();
										var year = date.getFullYear();

										var hours = date.getHours();
										var minutes = date.getMinutes();
										var seconds = date.getSeconds();

										var ampm = hours >= 12 ? "PM" : "AM";
										hours = hours % 12;
										hours = hours ? hours : 12;

										minutes = minutes < 10 ? "0" + minutes : minutes;
										seconds = seconds < 10 ? "0" + seconds : seconds;

										return month + " " + day + ", " + year + " " +
											hours + ":" + minutes + ":" + seconds + " " + ampm;
									}
									function userPath(id) {
										vm.userGeofences = [];
										vm.assetFilterGeofences = [];
										vm.selectedUserGeofenceId = null;
										vm.prevSelectedUserGeofenceId = null;
										var ele = document.getElementById("userPathModal");
										$(ele).modal('show');
										vm.drawUserPath(id);
										userIdSelected = id;
										var cleratodatefromdate = vm.today();
									}
									var infowindowPopup = new google.maps.InfoWindow({
										content: userContent,
										pixelOffset: new google.maps.Size(0, -50),
									});

									

									customMarker.prototype = new google.maps.OverlayView();

									customMarker.prototype.draw = function () {
										var self = this;
										var div = this.div;

										if (!div) {

											div = this.div = document.createElement('div');
											div.id = 'marker';
											div.style.width = '100px';
											div.style.height = '100px';

											var div_pointer = document.createElement('div');
											div_pointer.className = 'triangle';

											var image_container = document.createElement('div');
											image_container.className = 'image_container';

											var img = document.createElement('img');
											img.className = "marker_image";
											var image2 = "data:image/png;base64,";
											image2 += value.userImage;
											if (value.userImage == undefined) {
												image2 = "content/images/userimg.gif";
											}

											img.src = image2;

											var name_container = document.createElement('div');
											name_container.className = 'name_container';

											var exit = document.createElement('div');
											exit.className = 'exit';
											exit.innerHTML = '<img className="exit_image" style="width:30px; height:30px;" src="https://cdn0.iconfinder.com/data/icons/large-glossy-icons/512/Delete.png">'
												+ '</img>';
											exit.style.display = 'none';

											div.appendChild(image_container);
											image_container.appendChild(img);
											image_container.appendChild(imgbg);

											div.appendChild(exit);

											name_container.onmouseover = function () {
												name_container.style.opacity = '0.6';
												div.style.zIndex = '1000'
											};
											name_container.onmouseout = function () {
												name_container.style.opacity = '0';
												div.style.zIndex = '100'
											};

											if (this.status === 'ABSENT') {
												div.style.opacity = '0.5';
											}

											// add content to
											// InfoWindow for
											// click event
											infoWindow2.setContent('<div class="infoWindowhead">' + value.login + '</div>' + userContent);
											if (activeInfoWindow != null)
												activeInfoWindow.close();

											google.maps.event.addDomListener(imgbg, 'click', function (event) {
												infowindowPopup.setPosition(new google.maps.LatLng(value.latitude, value.longitude));
												infowindowPopup.open(locations.map);

												if (activeInfoWindow != null)
													activeInfoWindow.close();

												activeInfoWindow = infowindowPopup;

											});

											google.maps.event.addDomListener(imgbg, "click", function (event) {
												google.maps.event.trigger(self, "click");

												infowindowPopup.open(locations.map);
											});

											var panes = this.getPanes();

											panes.overlayImage.appendChild(div);

										}

										var point = this.getProjection().fromLatLngToDivPixel(this.latlng);

										if (point) {
											div.style.left = (point.x - 50) + 'px';
											div.style.top = (point.y - 125) + 'px';
										}
									}
									
									customMarker.prototype.remove = function () {

										if (this.div) {
											this.div.parentNode.removeChild(this.div);
											this.div = null;
										}
									}

									customMarker.prototype.getPosition = function () {
										return this.latlng;
									}
									markers.forEach(function (marker) {
										// image =
										// value.userImage;

										var overlay = new customMarker();
									});
									var overlay = new customMarker();
									userMarkersMap[value.userid] = overlay;


								}
							});

							locations.map.fitBounds(bounds);
						});
					});
			}
			drawLatestVehicles(vm.vehicles);

		}
		var lastHoveredUserId = null;

		$scope.highlightUser = function (userId) {
			if (lastHoveredUserId === userId) return;

			lastHoveredUserId = userId;

			var marker = userMarkersMap[userId];
			if (marker && marker.latlng) {
				locations.map.panTo(marker.latlng);
				locations.map.setOptions({
					gestureHandling: 'greedy'
				});
				if (locations.map.getZoom() < 16) {
					locations.map.setZoom(16);
				}
				if (marker.div) {
				    marker.div.style.transform = 'scale(2)';
				}
			}
		};


		$scope.removeHighlight = function (userId) {
			var marker = userMarkersMap[userId];
			if (marker && marker.div) {
				marker.div.style.transform = 'scale(1)';
				marker.div.style.zIndex = '100';
				marker.div.style.boxShadow = 'none';
			}
			locations.map.setZoom(14);
		};

		function setupUsersMap(callback) {

			locations.map = new google.maps.Map(document.getElementById("map_canvas"), myOption(21, locations.latlng));
			geoLocation(locations.map)
			locations.overlay = new google.maps.OverlayView();
			locations.overlay.draw = function () {
			};
			locations.overlay.setMap($scope.map);
			locations.element = document.getElementById('map_canvas');
			callback();
			if (vm.assetTypeValues != null) {
				if (vm.assetTypeValues.length > 0) {
					for (var index = 0; index < vm.assetTypeValues.length; index++) {
						var assetType = vm.assetTypeValues[index];
						var typeName = assetType.assetTypeName;
						var typeAssetsList = [];
						if (assetType.assets != null) {
							typeAssetsList = assetType.assets;
						}

						vm.mapAssets.forEach(function (asset) {
							if (typeName == asset.assetTypeName) {
								typeAssetsList.push(asset);
							}
						});
						assetType.assets = typeAssetsList;
						vm.assetTypeValues[index] = assetType;
					}
					var assetList = [];
					for (var index = 0; index < vm.assetTypeValues.length; index++) {
						vm.assetTypeValues[index].assets.forEach(function (assetVal) {
							assetList.push(assetVal);
						});
					}
					drawAssets(assetList);
				}
			}
		}

		function drawAssets(response) {
			if (response) {
				$.each(response, function (index, value) {
					if (value.assetTypeLayout == null) {
						value.assetTypeName = value.assetType.name;
						value.assetTypeLayout = value.assetType.layout;
						value.assetTypeImagePath = value.assetType.imagePath;
					}
					if (value.assetTypeLayout != null && value.assetTypeLayout == 'FIXED') {
						if (value.assetCoordinates.length > 1) {
							var value1 = value;
							value1.assetCoordinates = [value.assetCoordinates[value.assetCoordinates.length - 1]];

							drawFixedAsset(value1, false);

						} else {
							drawFixedAsset(value, false);
						}
					}
					if (value.assetTypeLayout != null && value.assetTypeLayout == 'SPREAD') {
						drawPolyline(value, locations.map);
					}

				});
			}
		}

		function drawAssetsForPath(response) {
			if (response) {
				$.each(response, function (index, value) {
					if (value.assetTypeLayout == null) {
						value.assetTypeName = value.assetType.name;
						value.assetTypeLayout = value.assetType.layout;
						value.assetTypeImagePath = value.assetType.imagePath;
					}
					if (value.assetTypeLayout != null && value.assetTypeLayout == 'FIXED') {
						if (value.assetCoordinates.length > 1) {
							var value1 = value;
							value1.assetCoordinates = [value.assetCoordinates[value.assetCoordinates.length - 1]];

							drawFixedAssetForPath(value1, false);

						} else {
							drawFixedAssetForPath(value, false);
						}
					}
					if (value.assetTypeLayout != null && value.assetTypeLayout == 'SPREAD') {
						drawPolylineForPath(value, userPaths.map);
					}

				});
			}
		}

		function drawFixedAsset(fixed, hasParent) {

			$.each(fixed.assetCoordinates, function (index, value1) {
				if (openedInfoWindow != null) {
					openedInfoWindow.close();
				}

				var infoWindow = new google.maps.InfoWindow();


				var iconUrl = "";
				var isFixedAsset = false;
				iconUrl = fixed.assetTypeImagePath;
				isFixedAsset = true;

				var iconSize = 8;


				if (isFixedAsset) {
					iconSize = 24;
				}

				var startMarker = new google.maps.Marker({
					map: locations.map,
					position: new google.maps.LatLng(
						value1.latitude,
						value1.longitude),
					title: fixed.name,
					icon: {
						scaledSize: new google.maps.Size(
							iconSize, iconSize),
						url: iconUrl,
						anchor: new google.maps.Point(
							iconSize / 2, iconSize / 2),
					},
				});

				markers.push(startMarker);

				var infoWindow2 = new google.maps.InfoWindow();
				var infoStr = "";
				var otdr = "";

				var userContent = document.createElement('div'),
					button;

				userContent.innerHTML = '<div class="infoWindowhead">' + startMarker.title +
					'</div><div class="infoWindowContent">' +
					'<b>Lat</b> :' +
					fixed.assetCoordinates[fixed.assetCoordinates.length - 1].latitude +
					'<br><b>Long</b> :' +
					fixed.assetCoordinates[fixed.assetCoordinates.length - 1].longitude +
					'<br>' + infoStr + '</div>';

				google.maps.event.addListener(startMarker,
					'dblclick',
					function () {
						infoWindow2.close();
					});

				var activeInfoWindow;
				var infoWindow2 = new google.maps.InfoWindow({
					content: userContent
				});
				// add listener on InfoWindow for click
				// event
				google.maps.event.addListener(startMarker, 'click', function () {
					AssetByID.get(fixed.id, function (response) {
						var infoWindow2 = new google.maps.InfoWindow();
						var infoStr = "";
						var otdr = "";
						var assetTypeAttributeValuesList = response.assetTypeAttributeValues;
						assetTypeAttributeValuesList.sort(function (a, b) {
							var nameA = a.assetTypeAttribute.name.toLowerCase(),
								nameB = a.assetTypeAttribute.name.toLowerCase()
							if (nameA < nameB) // sort string ascending
								return -1
							if (nameA > nameB)
								return 1
							return 0 // default return value (no sorting)
						});
						for (var i = 0; i < assetTypeAttributeValuesList.length; i++) {
							var home = assetTypeAttributeValuesList[i];
							infoStr += '<br><b>' +
								home.assetTypeAttribute.name +
								'</b> : ' +
								home.attributeValue;
							otdr = home;
						}

						var userContent = document.createElement('div'),
							button;
						userContent.innerHTML = '<div class="infoWindowhead">' + "<b>Name</b> : " + startMarker.title +
							'</div><div class="infoWindowContent">' +
							"<b>Asset Type</b> : " + fixed.assetTypeName +
							"<br><b>Latitude</b> :" +
							fixed.assetCoordinates[fixed.assetCoordinates.length - 1].latitude +
							'<br><b>Longitude</b> :' +
							fixed.assetCoordinates[fixed.assetCoordinates.length - 1].longitude +
							'<br>' + infoStr + '</div>';

						button = userContent.appendChild(document.createElement('input'));
						button.type = 'button';
						button.value = 'Creat Incident';
						button.className = "button";

						google.maps.event.addDomListener(button, 'click', function () {
							$state.go("tr-case.new", {
								'lat': fixed.assetCoordinates[fixed.assetCoordinates.length - 1].latitude,
								'lng': fixed.assetCoordinates[fixed.assetCoordinates.length - 1].longitude,
								'desc': "Incident for " + fixed.name
							});
						});


						var infoWindow2 = new google.maps.InfoWindow({
							content: userContent
						});
						if (prevInfoWindow != null)
							prevInfoWindow.close();
						infoWindow2.open(locations.map, startMarker);
						setTimeout(function () { infoWindow2.close(); }, 5000);

						activeInfoWindow = infoWindow2;
						prevInfoWindow = infoWindow2;
					});

				});
				openedInfoWindow = infoWindow2;
			});
		}

		function drawPolyline(spread, map) {

			var spreadAssetCoordinates = [];
			var spreadColor = 0;
			var spreadWidth = 0;
			var spreadOpacity = 0;

			vm.assetTypes.forEach(function (assetType) {
				if (assetType.name == spread.assetTypeName) {
					spreadColor = assetType.colorcode;
					spreadWidth = assetType.lineWidth * 0.05;
					spreadOpacity = assetType.transparency * 0.01;
				}
			});

			$.each(spread.assetCoordinates, function (index, value) {

				spreadAssetCoordinates.push({
					lat: value.latitude,
					lng: value.longitude
				});
			});
			if (spreadAssetCoordinates.length > 1) {
				var midLatLng = {
					lat: spread.assetCoordinates[spread.assetCoordinates.length - 1].latitude,
					lng: spread.assetCoordinates[spread.assetCoordinates.length - 1].longitude
				};

				var polylineColor = '';
				var distanceFromPOP = '';
				var fiberCoreVal = '';
				var infowindow = null;
				if (spread.assetTypeLayout == "SPREAD") {
					polylineColor = spreadColor;
				}
				var polylineWeight = spreadWidth;
				var strokeOpacityVal = spreadOpacity;

				var polylinepath = new google.maps.Polyline({
					path: spreadAssetCoordinates,
					geodesic: true,
					strokeColor: polylineColor,
					strokeOpacity: strokeOpacityVal,
					strokeWeight: polylineWeight,
					fillColor: polylineColor,
					fillOpacity: 0.3,
					editable: false,
				});

				google.maps.event.addListener(polylinepath, 'click', function (event) {
					if (openedInfoWindow != null) {
						openedInfoWindow.close();
					}
					var disVal = 0;
					var cLocations = [];

					if (spread.description == null || spread.description == undefined) {
						spread.description = "";
					}

					if (spread.assetTypeLayout == "SPREAD") {
						AssetByID.get(spread.id, function (assetVal) {
							spread = assetVal;
							var infoStr = "";
							var assetTypeAttributeValuesList = spread.assetTypeAttributeValues;
							assetTypeAttributeValuesList.sort(function (a, b) {
								var nameA = a.assetTypeAttribute.name.toLowerCase(),
									nameB = b.assetTypeAttribute.name.toLowerCase()
								if (nameA < nameB) // sort string ascending
									return -1
								if (nameA > nameB)
									return 1
								return 0 // default return value (no sorting)
							});
							for (var i = 0; i < assetTypeAttributeValuesList.length; i++) {
								var home = assetTypeAttributeValuesList[i];

								var attrVal = "";
								if (home.attributeValue != null) {
									attrVal = home.attributeValue;
								}
								infoStr += '<br><b>' +
									home.assetTypeAttribute.name +
									'</b> : ' +
									attrVal;
							}
							var spreadCoordinates = spread.assetCoordinates;
							if (spreadCoordinates.length > 0) {
								for (var index in spreadCoordinates) {
									if (index > 0) {
										disVal += distanceCal(spreadCoordinates[index].latitude, spreadCoordinates[index].longitude, spreadCoordinates[index - 1].latitude, spreadCoordinates[index - 1].longitude);
									}
								}
							}

							var userContent = document.createElement('div');

							userContent.innerHTML = '<div class="infoWindowhead">' +
								'<b>Name : </b> ' + spread.name + "<br><b>Asset Type : </b> " + spread.assetType.name + '</br>' +
								'<b>Distance : </b> ' + (parseFloat(disVal)).toFixed(2) + ' Km</br>';

							infowindow = new google.maps.InfoWindow({
								content: userContent
							});
						});
					}
					if (infowindow != null) {
						infowindow.setPosition(event.latLng);
						infowindow.open(locations.map);
						openedInfoWindow = infowindow;
					}
				});

				var polylinepathDuct = new google.maps.Polyline({
					path: spreadAssetCoordinates,
					geodesic: true,
					strokeColor: polylineColor,
					strokeOpacity: 1,
					strokeWeight: 2,
					fillColor: polylineColor,
					fillOpacity: 0.3,
					editable: false
				});

				polylinepath.setMap(locations.map);
				polylines.push(polylinepath);
			}
		}

		function drawFixedAssetForPath(fixed, hasParent) {

			$.each(fixed.assetCoordinates, function (index, value1) {
				if (openedInfoWindow != null) {
					openedInfoWindow.close();
				}

				var infoWindow = new google.maps.InfoWindow();


				var iconUrl = "";
				var isFixedAsset = false;
				iconUrl = fixed.assetTypeImagePath;
				isFixedAsset = true;

				var iconSize = 16;
				if (isFixedAsset) {
					iconSize = 24;
				}

				var startMarker = new google.maps.Marker({
					map: userPaths.map,
					position: new google.maps.LatLng(
						value1.latitude,
						value1.longitude),
					title: fixed.name,
					icon: {
						scaledSize: new google.maps.Size(
							iconSize, iconSize),
						url: iconUrl,
						anchor: new google.maps.Point(
							iconSize / 2, iconSize / 2),
					},
				});

				markersForPath.push(startMarker);

				var infoWindow2 = new google.maps.InfoWindow();
				var infoStr = "";
				var otdr = "";

				var userContent = document.createElement('div'),
					button;

				userContent.innerHTML = '<div class="infoWindowhead">' + startMarker.title +
					'</div><div class="infoWindowContent">' +
					'<b>Lat</b> :' +
					fixed.assetCoordinates[fixed.assetCoordinates.length - 1].latitude +
					'<br><b>Long</b> :' +
					fixed.assetCoordinates[fixed.assetCoordinates.length - 1].longitude +
					'<br>' + infoStr + '</div>';

				google.maps.event.addListener(startMarker,
					'dblclick',
					function () {
						infoWindow2.close();
					});

				var activeInfoWindow;
				var infoWindow2 = new google.maps.InfoWindow({
					content: userContent
				});
				// add listener on InfoWindow for click
				// event
				google.maps.event.addListener(startMarker, 'click', function () {
					AssetByID.get(fixed.id, function (response) {
						var infoWindow2 = new google.maps.InfoWindow();
						var infoStr = "";
						var otdr = "";
						var assetTypeAttributeValuesList = response.assetTypeAttributeValues;
						assetTypeAttributeValuesList.sort(function (a, b) {
							var nameA = a.assetTypeAttribute.name.toLowerCase(),
								nameB = a.assetTypeAttribute.name.toLowerCase()
							if (nameA < nameB) // sort string ascending
								return -1
							if (nameA > nameB)
								return 1
							return 0 // default return value (no sorting)
						});
						for (var i = 0; i < assetTypeAttributeValuesList.length; i++) {
							var home = assetTypeAttributeValuesList[i];
							infoStr += '<br><b>' +
								home.assetTypeAttribute.name +
								'</b> : ' +
								home.attributeValue;
							otdr = home;
						}

						var userContent = document.createElement('div'),
							button;
						userContent.innerHTML = '<div class="infoWindowhead">' + "<b>Name</b> : " + startMarker.title +
							'</div><div class="infoWindowContent">' +
							"<b>Asset Type</b> : " + fixed.assetTypeName +
							"<br><b>Latitude</b> :" +
							fixed.assetCoordinates[fixed.assetCoordinates.length - 1].latitude +
							'<br><b>Longitude</b> :' +
							fixed.assetCoordinates[fixed.assetCoordinates.length - 1].longitude +
							'<br>' + infoStr + '</div>';

						button = userContent.appendChild(document.createElement('input'));
						button.type = 'button';
						button.value = 'Creat Incident';
						button.className = "button";

						google.maps.event.addDomListener(button, 'click', function () {
							$state.go("tr-case.new", {
								'lat': fixed.assetCoordinates[fixed.assetCoordinates.length - 1].latitude,
								'lng': fixed.assetCoordinates[fixed.assetCoordinates.length - 1].longitude,
								'desc': "Incident for " + fixed.name
							});
						});


						var infoWindow2 = new google.maps.InfoWindow({
							content: userContent
						});
						if (prevInfoWindow != null)
							prevInfoWindow.close();
						infoWindow2.open(userPaths.map, startMarker);
						setTimeout(function () { infoWindow2.close(); }, 5000);

						activeInfoWindow = infoWindow2;
						prevInfoWindow = infoWindow2;
					});

				});
				openedInfoWindow = infoWindow2;
			});
		}
		vm.toggleAssets = function () {
			if (vm.showAssets) {
				hideAllAssets();
			} else {
				showAllAssets();
			}
		};
		function hideAllAssets() {
		for (var i = 0; i < markersForPath.length; i++) {
			markersForPath[i].setMap(null);
		}
		}

		function showAllAssets() {
			for (var i = 0; i < markersForPath.length; i++) {
				markersForPath[i].setMap(userPaths.map);
			}
		}
		function drawPolylineForPath(spread, map) {

			var spreadAssetCoordinates = [];
			var spreadColor = 0;
			var spreadWidth = 0;
			var spreadOpacity = 0;

			vm.assetTypes.forEach(function (assetType) {
				if (assetType.name == spread.assetTypeName) {
					spreadColor = assetType.colorcode;
					spreadWidth = assetType.lineWidth * 0.05;
					spreadOpacity = assetType.transparency * 0.01;
				}
			});
			$.each(spread.assetCoordinates, function (index, value) {

				spreadAssetCoordinates.push({
					lat: value.latitude,
					lng: value.longitude
				});
			});
			if (spreadAssetCoordinates.length > 1) {
				var midLatLng = {
					lat: spread.assetCoordinates[spread.assetCoordinates.length - 1].latitude,
					lng: spread.assetCoordinates[spread.assetCoordinates.length - 1].longitude
				};

				var polylineColor = '';
				var distanceFromPOP = '';
				var fiberCoreVal = '';
				var infowindow = null;
				if (spread.assetTypeLayout == "SPREAD") {
					polylineColor = spreadColor;
				}
				var polylineWeight = spreadWidth;
				var strokeOpacityVal = spreadOpacity;

				var polylinepath = new google.maps.Polyline({
					path: spreadAssetCoordinates,
					geodesic: true,
					strokeColor: polylineColor,
					strokeOpacity: strokeOpacityVal,
					strokeWeight: polylineWeight,
					fillColor: polylineColor,
					fillOpacity: 0.3,
					editable: false
				});

				google.maps.event.addListener(polylinepath, 'click', function (event) {
					if (openedInfoWindow != null) {
						openedInfoWindow.close();
					}
					var disVal = 0;
					var cLocations = [];

					if (spread.description == null || spread.description == undefined) {
						spread.description = "";
					}

					if (spread.assetTypeLayout == "SPREAD") {
						AssetByID.get(spread.id, function (assetVal) {
							spread = assetVal;
							var infoStr = "";
							var assetTypeAttributeValuesList = spread.assetTypeAttributeValues;
							assetTypeAttributeValuesList.sort(function (a, b) {
								var nameA = a.assetTypeAttribute.name.toLowerCase(),
									nameB = b.assetTypeAttribute.name.toLowerCase()
								if (nameA < nameB) // sort string ascending
									return -1
								if (nameA > nameB)
									return 1
								return 0 // default return value (no sorting)
							});
							for (var i = 0; i < assetTypeAttributeValuesList.length; i++) {
								var home = assetTypeAttributeValuesList[i];

								var attrVal = "";
								if (home.attributeValue != null) {
									attrVal = home.attributeValue;
								}
								infoStr += '<br><b>' +
									home.assetTypeAttribute.name +
									'</b> : ' +
									attrVal;
							}
							var spreadCoordinates = spread.assetCoordinates;
							if (spreadCoordinates.length > 0) {
								for (var index in spreadCoordinates) {
									if (index > 0) {
										disVal += distanceCal(spreadCoordinates[index].latitude, spreadCoordinates[index].longitude, spreadCoordinates[index - 1].latitude, spreadCoordinates[index - 1].longitude);
									}
								}
							}

							var userContent = document.createElement('div');

							userContent.innerHTML = '<div class="infoWindowhead">' +
								'<b>Name : </b> ' + spread.name + "<br><b>Asset Type : </b> " + spread.assetType.name + '</br>' +
								'<b>Distance : </b> ' + (parseFloat(disVal)).toFixed(2) + ' Km</br>';

							infowindow = new google.maps.InfoWindow({
								content: userContent
							});
						});
					}
					if (infowindow != null) {
						infowindow.setPosition(event.latLng);
						infowindow.open(userPaths.map);
						openedInfoWindow = infowindow;
					}
				});

				var polylinepathDuct = new google.maps.Polyline({
					path: spreadAssetCoordinates,
					geodesic: true,
					strokeColor: polylineColor,
					strokeOpacity: 1,
					strokeWeight: 2,
					fillColor: polylineColor,
					fillOpacity: 0.3,
					editable: false
				});

				polylinepath.setMap(userPaths.map);

				polylinesForPath.push(polylinepath);
			}
		}

		function drawlines(paths) {
			vm.userPathName = paths.userName;
			var userData = paths;
			if (paths.path.length > 0) {

				var data = [{
					"latitude": paths.path[0].lat,
					"longitude": paths.path[0].lng
				}];
			} else {
				var data = [{
					"latitude": parseFloat($rootScope.DEFAULT_LATITUDE),
					"longitude": parseFloat($rootScope.DEFAULT_LONGITUDE)
				}];
			}
			initializeMap(data, function (latlang) {
				userPaths.latlng = latlang;
				setupMap(function () {
					if (paths && paths.path && paths.path.length > 0) {
						loadUserPaths(paths);
					} else {
						//						resizeMap();
						if (vm.type == "user") {
							UsersGeoFenceData.getGeoFenceData(markerUserName, function (response) {
								vm.userGeofences = [];
								vm.assetFilterGeofences = [];
								$.each(response, function (index, value) {
									if (index === 0) {
										console.log("hello");
            vm.displayGeofenceCasesInLOadTravel(value.id);
            console.log("Called for first geofence:", value.id);
        }
									console.log(value.id)
									if (value.geofenceType != "MASTER") {
										if (value.geofenceType == "MINI") {
											vm.userGeofences.push(value);
											value.label = value.name.substring(0, 15) + "..";
											value.ticked = false;
											vm.assetFilterGeofences.push(value);
											if (vm.selectedUserGeofenceId == null) {
												vm.selectedUserGeofenceId = value.id;
												vm.canUserGeofenceFilter = true;
												vm.mapUserAssets = [];
												AssetTypesByGeofenceID.get(vm.selectedUserGeofenceId, function (assetTypeVal) {
													vm.assetTypeValuesPath = assetTypeVal;
													getGroupAssetsFromDBPath(vm.selectedUserGeofenceId, null, vm.mapUserAssets);
												});
											}
										} else {
											vm.userGeofences.push(value);
										}
									}
								});
							});
						} else {
							VehicleGeoFenceData.getGeoFenceData(paths.id, function (response) {
								vm.userGeofences = [];
								vm.assetFilterGeofences = [];
								$.each(response, function (index, value) {
									if (index === 0) {
										console.log("hello");
            vm.displayGeofenceCasesInLOadTravel(value.id);
            console.log("Called for first geofence:", value.id);
        }
									console.log(value.id)
									if (value.geofenceType != "MASTER") {
										if (value.geofenceType == "MINI") {
											vm.userGeofences.push(value);
											value.label = value.name.substring(0, 15) + "..";
											value.ticked = false;
											vm.assetFilterGeofences.push(value);
											if (vm.selectedUserGeofenceId == null) {
												vm.selectedUserGeofenceId = value.id;
												vm.canUserGeofenceFilter = true;
												vm.mapUserAssets = [];
												AssetTypesByGeofenceID.get(vm.selectedUserGeofenceId, function (assetTypeVal) {
													vm.assetTypeValuesPath = assetTypeVal;
													getGroupAssetsFromDBPath(vm.selectedUserGeofenceId, null, vm.mapUserAssets);
												});
											}
										} else {
											vm.userGeofences.push(value);
										}
									}
								});
							});
						}
						vm.totalDistance = 0;
						$scope.totalDistanceTravelled = "0 kms";
						vm.inProgressDistance = 0
						console.log('there are no user agents found');
					}
				});

				function groupByDeviceAndApp(pathArr) {
					var grouped = {};

					for (var i = 0; i < pathArr.length; i++) {
						var p = pathArr[i];
						var device = p.deviceName || "UNKNOWN_DEVICE";
						var app = p.appName || "UNKNOWN_APP";

						if (!grouped[device]) {
							grouped[device] = {};
						}
						if (!grouped[device][app]) {
							grouped[device][app] = [];
						}

						grouped[device][app].push(p);
					}
					return grouped;
				}

				function drawGroupedPath(pathArr, paths) {
					var prevCor = null;

					for (var i = 0; i < pathArr.length; i++) {
						var pathIn = [];
						var pathOut = [];
						var curr = pathArr[i];
						var color, label;
						if(curr.deviceName=='null'||curr.deviceName==null){
							curr.deviceName='Mobile';
						}
						if (curr.geofenceStatus === "IN") {
							pathIn.push(curr);
							color = "green";
							label = "Inside Geofence <br> "+curr.deviceName;
						} else if (curr.geofenceStatus === "OUT" || curr.geofenceStatus === "OTHER") {
							pathOut.push(curr);
							color = "orange";
							label = "Outside Geofence <br> "+curr.deviceName;
						} else {
							color = "DarkBlue";
							label = "Other";
						}

						if (prevCor != null) {
							var coordinatesList = [];
							coordinatesList.push(prevCor);
							coordinatesList.push(curr);

							drawPolylineForGeoFence(
								coordinatesList,
								userPaths.map,
								color,
								label,
								paths
							);
						}
						prevCor = curr;
						
						drawMarkers(paths, pathArr, pathIn, "green");
						drawMarkers(paths, pathArr, pathOut, "orange");
					}
				}

				function loadUserPaths(paths) {

					var pathArr = paths.path;

					// Group paths
					var groupedPaths = groupByDeviceAndApp(pathArr);

					// Iterate deviceName → appName
					for (var deviceName in groupedPaths) {
						for (var appName in groupedPaths[deviceName]) {

							var groupedArray = groupedPaths[deviceName][appName];

							// Optional: sort by time before drawing
							groupedArray.sort(function (a, b) {
								return a.createdDateTime - b.createdDateTime;
							});

							// Draw polyline for this device+app
							drawGroupedPath(groupedArray, paths);
						}
					}

					// // Existing marker & geofence logic stays SAME
					// drawMarkers(paths, pathArr, [], "green");

					if (vm.type == "user") {
						UsersGeoFenceData.getGeoFenceData(markerUserName, function (response) {
							vm.displayGeofenceCasesInLOadTravel(response[0].id);
							vm.userGeofences = [];
							vm.assetFilterGeofences = [];
							$.each(response, function (index, value) {
								if (value.geofenceType != "MASTER") {
									if (value.geofenceType == "MINI") {
										vm.userGeofences.push(value);
										value.label = value.name.substring(0, 15) + "..";
										value.ticked = false;
										vm.assetFilterGeofences.push(value);
										if (vm.selectedUserGeofenceId == null) {
											vm.selectedUserGeofenceId = value.id;		
											vm.mapUserAssets = [];
											AssetTypesByGeofenceID.get(vm.selectedUserGeofenceId, function (assetTypeVal) {
												vm.assetTypeValuesPath = assetTypeVal;
												getGroupAssetsFromDBPath(vm.selectedUserGeofenceId, null, vm.mapUserAssets);
											});
											vm.canUserGeofenceFilter = true;
										}
										var coordinatesList = JSON.parse(value.coordinates);
										coordinatesList.push(coordinatesList[0]);
										drawPolylineForGeoFence(coordinatesList, userPaths.map, "blue", value.name,paths);
									} else {
										vm.userGeofences.push(value);
										var coordinatesList = JSON.parse(value.coordinates);
										coordinatesList.push(coordinatesList[0]);
										drawPolylineForGeoFence(coordinatesList, userPaths.map, "blue", value.name,paths);
									}
								}
							});
						});
					} else {
						VehicleGeoFenceData.getGeoFenceData(paths.id, function (response) {
							vm.displayGeofenceCasesInLOadTravel(response[0].id);
							vm.userGeofences = [];
							vm.assetFilterGeofences = [];
							$.each(response, function (index, value) {
								if (value.geofenceType != "MASTER") {
									if (value.geofenceType == "MINI") {
										vm.userGeofences.push(value);
										value.label = value.name.substring(0, 15) + "..";
										value.ticked = false;
										vm.assetFilterGeofences.push(value);
										if (vm.selectedUserGeofenceId == null) {
											vm.selectedUserGeofenceId = value.id;
											vm.mapUserAssets = [];
											AssetTypesByGeofenceID.get(vm.selectedUserGeofenceId, function (assetTypeVal) {
												vm.assetTypeValuesPath = assetTypeVal;
												getGroupAssetsFromDBPath(vm.selectedUserGeofenceId, null, vm.mapUserAssets);
											});
											vm.canUserGeofenceFilter = true;
										}
										var coordinatesList = JSON.parse(value.coordinates);
										coordinatesList.push(coordinatesList[0]);
										drawPolylineForGeoFence(coordinatesList, userPaths.map, "blue", value.name,paths);
									} else {
										vm.userGeofences.push(value);
										var coordinatesList = JSON.parse(value.coordinates);
										coordinatesList.push(coordinatesList[0]);
										drawPolylineForGeoFence(coordinatesList, userPaths.map, "blue", value.name,paths);
									}
								}
							});
						});
					}

					if (vm.selectedUserGeofenceId != null) {
						vm.mapUserAssets = [];
						AssetTypesByGeofenceID.get(vm.selectedUserGeofenceId, function (assetTypeVal) {
							vm.assetTypeValuesPath = assetTypeVal;
							getGroupAssetsFromDBPath(vm.selectedUserGeofenceId, null, vm.mapUserAssets);
						});
					}

					Report.getReportingReport({
						id: userIdSelected,
						fromTime: vm.fromDate.getTime(),
						toTime: vm.toDate.getTime()
					}, function (response) {
						response.forEach(function (reporting) {

							if (reporting.userLatitude > 0 && reporting.userLongitude > 0) {
								var iconUrl = 'content/images/Pointer-C4.png';
								if (reporting.reportType == "CHECKIN") {
									iconUrl = 'content/images/Pointers-L4.png';
								} else {
									iconUrl = 'content/images/Pointer-C4.png';
								}
								var startMarker = new google.maps.Marker({
									map: userPaths.map,
									position: new google.maps.LatLng(
										reporting.userLatitude,
										reporting.userLongitude),
									icon: iconUrl,
									title: reporting.userLogin
								});

								google.maps.event.addListener(startMarker, 'click', function (event) {
									var date = new Date(reporting.dateTime);
									var infowindow = new google.maps.InfoWindow(
										{
											content: '<div class="infoWindowhead">' +
												'<b>Name : </b> ' + reporting.userLogin + '</br>' +
												'<b>Reporting Status : </b> ' + reporting.reportType + '</br>' +
												'<b>Reporting Time : </b> ' + date.toString() + '</br>' +
												'<b>LatLng : </b> ' + reporting.userLatitude + ', ' + reporting.userLongitude + '</br>'
										});
									infowindow.open(userPaths.map);
									infowindow.setPosition(event.latLng);
								});
							}
						});
					});
				}

				// function loadUserPaths(paths) {
				// 	var pathIn = [];
				// 	var pathOut = [];
				// 	var pathArr = paths.path;
				// 	var prevCor = null;
				// 	var pathOther = []

				// 	for (var i = 0; i < pathArr.length; i++) {
				// 		if (pathArr[i].geofenceStatus == "IN") {
				// 			pathIn.push(pathArr[i]);

				// 			if (prevCor != null) {
				// 				var coordinatesList = [];
				// 				coordinatesList.push(prevCor);
				// 				coordinatesList.push(pathArr[i]);
				// 				drawPolylineForGeoFence(coordinatesList, userPaths.map, "green", "Inside Geofence",paths);
				// 			}
				// 		} else if (pathArr[i].geofenceStatus == "OUT") {
				// 			pathOut.push(pathArr[i]);

				// 			if (prevCor != null) {
				// 				var coordinatesList = [];
				// 				coordinatesList.push(prevCor);
				// 				coordinatesList.push(pathArr[i]);
				// 				drawPolylineForGeoFence(coordinatesList, userPaths.map, "orange", "Outside Geofence",paths);
				// 			}
				// 		} else {
				// 			pathOther.push(pathArr[i]);

				// 			if (prevCor != null) {
				// 				var coordinatesList = [];
				// 				coordinatesList.push(prevCor);
				// 				coordinatesList.push(pathArr[i]);
				// 				drawPolylineForGeoFence(coordinatesList, userPaths.map, "DarkBlue", "Other",paths);
				// 			}
				// 		}
				// 		prevCor = pathArr[i];
				// 	}

				// 	drawMarkers(paths, pathArr, pathIn, "green");
				// 	drawMarkers(paths, pathArr, pathOut, "orange");
				// 	if (vm.type == "user") {
				// 		UsersGeoFenceData.getGeoFenceData(markerUserName, function (response) {
				// 			vm.userGeofences = [];
				// 			vm.assetFilterGeofences = [];
				// 			$.each(response, function (index, value) {
				// 				if (value.geofenceType != "MASTER") {
				// 					if (value.geofenceType == "MINI") {
				// 						vm.userGeofences.push(value);
				// 						value.label = value.name.substring(0, 15) + "..";
				// 						value.ticked = false;
				// 						vm.assetFilterGeofences.push(value);
				// 						if (vm.selectedUserGeofenceId == null) {
				// 							vm.selectedUserGeofenceId = value.id;
				// 							vm.mapUserAssets = [];
				// 							AssetTypesByGeofenceID.get(vm.selectedUserGeofenceId, function (assetTypeVal) {
				// 								vm.assetTypeValuesPath = assetTypeVal;
				// 								getGroupAssetsFromDBPath(vm.selectedUserGeofenceId, null, vm.mapUserAssets);
				// 							});
				// 							vm.canUserGeofenceFilter = true;
				// 						}
				// 						var coordinatesList = JSON.parse(value.coordinates);
				// 						coordinatesList.push(coordinatesList[0]);
				// 						drawPolylineForGeoFence(coordinatesList, userPaths.map, "blue", value.name,paths);
				// 					} else {
				// 						vm.userGeofences.push(value);
				// 						var coordinatesList = JSON.parse(value.coordinates);
				// 						coordinatesList.push(coordinatesList[0]);
				// 						drawPolylineForGeoFence(coordinatesList, userPaths.map, "blue", value.name,paths);
				// 					}
				// 				}
				// 			});
				// 		});
				// 	} else {
				// 		VehicleGeoFenceData.getGeoFenceData(paths.id, function (response) {
				// 			vm.userGeofences = [];
				// 			vm.assetFilterGeofences = [];
				// 			$.each(response, function (index, value) {
				// 				if (value.geofenceType != "MASTER") {
				// 					if (value.geofenceType == "MINI") {
				// 						vm.userGeofences.push(value);
				// 						value.label = value.name.substring(0, 15) + "..";
				// 						value.ticked = false;
				// 						vm.assetFilterGeofences.push(value);
				// 						if (vm.selectedUserGeofenceId == null) {
				// 							vm.selectedUserGeofenceId = value.id;
				// 							vm.mapUserAssets = [];
				// 							AssetTypesByGeofenceID.get(vm.selectedUserGeofenceId, function (assetTypeVal) {
				// 								vm.assetTypeValuesPath = assetTypeVal;
				// 								getGroupAssetsFromDBPath(vm.selectedUserGeofenceId, null, vm.mapUserAssets);
				// 							});
				// 							vm.canUserGeofenceFilter = true;
				// 						}
				// 						var coordinatesList = JSON.parse(value.coordinates);
				// 						coordinatesList.push(coordinatesList[0]);
				// 						drawPolylineForGeoFence(coordinatesList, userPaths.map, "blue", value.name,paths);
				// 					} else {
				// 						vm.userGeofences.push(value);
				// 						var coordinatesList = JSON.parse(value.coordinates);
				// 						coordinatesList.push(coordinatesList[0]);
				// 						drawPolylineForGeoFence(coordinatesList, userPaths.map, "blue", value.name,paths);
				// 					}
				// 				}
				// 			});
				// 		});
				// 	}

				// 	if (vm.selectedUserGeofenceId != null) {
				// 		vm.mapUserAssets = [];
				// 		AssetTypesByGeofenceID.get(vm.selectedUserGeofenceId, function (assetTypeVal) {
				// 			vm.assetTypeValuesPath = assetTypeVal;
				// 			getGroupAssetsFromDBPath(vm.selectedUserGeofenceId, null, vm.mapUserAssets);
				// 		});
				// 	}

				// 	Report.getReportingReport({
				// 		id: userIdSelected,
				// 		fromTime: vm.fromDate.getTime(),
				// 		toTime: vm.toDate.getTime()
				// 	}, function (response) {
				// 		response.forEach(function (reporting) {

				// 			if (reporting.userLatitude > 0 && reporting.userLongitude > 0) {
				// 				var iconUrl = 'content/images/Pointer-C4.png';
				// 				if (reporting.reportType == "CHECKIN") {
				// 					iconUrl = 'content/images/Pointers-L4.png';
				// 				} else {
				// 					iconUrl = 'content/images/Pointer-C4.png';
				// 				}
				// 				var startMarker = new google.maps.Marker({
				// 					map: userPaths.map,
				// 					position: new google.maps.LatLng(
				// 						reporting.userLatitude,
				// 						reporting.userLongitude),
				// 					icon: iconUrl,
				// 					title: reporting.userLogin
				// 				});

				// 				google.maps.event.addListener(startMarker, 'click', function (event) {
				// 					var date = new Date(reporting.dateTime);
				// 					var infowindow = new google.maps.InfoWindow(
				// 						{
				// 							content: '<div class="infoWindowhead">' +
				// 								'<b>Name : </b> ' + reporting.userLogin + '</br>' +
				// 								'<b>Reporting Status : </b> ' + reporting.reportType + '</br>' +
				// 								'<b>Reporting Time : </b> ' + date.toString() + '</br>' +
				// 								'<b>LatLng : </b> ' + reporting.userLatitude + ', ' + reporting.userLongitude + '</br>'
				// 						});
				// 					infowindow.open(userPaths.map);
				// 					infowindow.setPosition(event.latLng);
				// 				});
				// 			}
				// 		});
				// 	});
				// }

				// added for calculating previous point start
				function previos_dist(i, markers) {
					var locDiff = 0;
					if (i > 0) {
						var data1 = markers[i];
						var data2 = markers[i - 1];
						var radlat1 = Math.PI * data1.lat / 180
						var radlat2 = Math.PI * data2.lat / 180
						var theta = data1.lng - data2.lng
						var radtheta = Math.PI * theta / 180
						var locDiff = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
						locDiff = Math.acos(locDiff)
						locDiff = locDiff * 180 / Math.PI
						locDiff = locDiff * 60 * 1.1515
						locDiff = locDiff * 1.609344
						locDiff = locDiff * 1000
					}
					return locDiff;
				}

				function drawMarkers(userdata, paths, userpath, colorVal) {
					var imgUrl = "content/images/dot.png";
					if (colorVal == "green") {
						imgUrl = "content/images/green_dot.png";
					} else {
						imgUrl = "content/images/orange_dot.png";
					}

					var markers = userpath;

					var infoWindow = new google.maps.InfoWindow();
					var lat_lng = new Array();

					var icon = {
						url: imgUrl, // url
						scaledSize: new google.maps.Size(5, 5),
						origin: new google.maps.Point(0, 0),
						anchor: new google.maps.Point(0, 0)
					};

					for (var i = 0; i < markers.length; i++) {
						var data = markers[i];
						var locDiff = previos_dist(i, markers);

						var myLatlng = new google.maps.LatLng(data.lat, data.lng);
						lat_lng.push(myLatlng);
						var marker = new google.maps.Marker({
							position: myLatlng,
							map: userPaths.map,
							icon: icon
						});

						(function (marker, data) {

							var logdate;
							if (data.updatedDateTime != 0) {
								logdate = new Date(data.updatedDateTime);

							} else {
								logdate = new Date(data.createdDateTime);
							}

							var logDateTime = $filter('date')(logdate, 'dd MMM HH:mm:ss');

							var travel_data = '<div class="infoWindowhead">' + logDateTime + '</div><div class="infoWindowContent"><div class="rows"><!--<p><strong>Address: </strong>' + data.address + '</p>--><p><strong>Coordinates(Lat , Long): </strong>' + data.lat.toFixed(4)
								+ ' , ' + data.lng.toFixed(4) + '</p><!--<p><strong>DistFromPrevLoc: </strong>' + locDiff.toFixed(2) + ' Meters</p>--></div></div>';

							google.maps.event.addListener(marker, "mouseover", function (e) {
								infoWindow.setContent(travel_data);
								infoWindow.open(userPaths.map, marker);
							});
							google.maps.event.addListener(marker, "mouseout", function (e) {
								infoWindow.close(userPaths.map, marker);
							});
						})(marker, data);


					}

					var infoWindow = new google.maps.InfoWindow();
					var distanceIn = userdata.distanceIn;
					var distanceOut = userdata.distanceOut;
					var distanceUnderived = userdata.distanceUnderived;

					var startMarker = new google.maps.Marker({
						map: userPaths.map,
						position: new google.maps.LatLng(paths[0].lat, paths[0].lng),
						title: 'Started here',
						icon: "content/images/green.png"
					});
					startMarker.content = '<div class="infoWindowhead">' + userdata.userName + '</div>';

					google.maps.event.addListener(startMarker, 'mouseover', function () {
						infoWindow.setContent(startMarker.content + '<div class="infoWindowContent">' + startMarker.title + '</div>');
						infoWindow.open(userPaths.map, startMarker);

					});
					google.maps.event.addListener(startMarker, 'mouseout', function () {
						infoWindow.close(userPaths.map, startMarker);
					});

					var infoWindow1 = new google.maps.InfoWindow();
					var endMarker = new google.maps.Marker({
						map: userPaths.map,
						position: new google.maps.LatLng(paths[paths.length - 1].lat, paths[paths.length - 1].lng),
						title: "Inside Geofence - " + (distanceIn).toFixed(2) + " Km and Outside Geofence " + (distanceOut).toFixed(2) + " Km",
						icon: "content/images/red.png"

					})
					if (vm.type == "user") {
						vm.totalDistance = (distanceIn + distanceOut + distanceUnderived).toFixed(2);
						$scope.totalDistanceTravelled = "   Inside Geofence - " + (distanceIn).toFixed(2) + " Km and Outside Geofence - " + (distanceOut).toFixed(2) + " Km";
						vm.inProgressDistance = (distanceUnderived).toFixed(2);
					} else {
						vm.totalDistance = (distanceIn).toFixed(2);
						$scope.totalDistanceTravelled = "";
					}


					endMarker.content = '<div class="infoWindowhead">' + userdata.userName + '</div>';

					google.maps.event.addListener(endMarker, 'mouseover', function () {

						infoWindow1.setContent(endMarker.content + '<div class="infoWindowContent">' + endMarker.title + '</div>');
						infoWindow1.open(userPaths.map, endMarker);

					});
					google.maps.event.addListener(endMarker, 'mouseout', function () {
						infoWindow1.close(userPaths.map, endMarker);
					});
				}
			});

		}

		function setupMap(callback) {

			userPaths.map = new google.maps.Map(document.getElementById("userPath_map_canvas"), myOption(13, userPaths.latlng));
			geoLocation(userPaths.map)
			userPaths.overlay = new google.maps.OverlayView();
			userPaths.overlay.draw = function () {
			};
			userPaths.overlay.setMap(userPaths.map);
			userPaths.element = document.getElementById('userPath');
			callback();
		}

		$scope.$on('$destroy', function () {
			$interval.cancel(updateLogs);
		});

		function initializeMap(latlangs, callback) {
			if (latlangs && latlangs.length > 0) {
				latlng = new google.maps.LatLng(latlangs[0].latitude, latlangs[0].longitude);
				callback(latlng);
			/* } else {
				if (navigator.geolocation) {
					navigator.geolocation.getCurrentPosition(function (position) {

						google.maps.event.trigger(locations.map, "resize");
						var centerlatlng = {
							lat: parseFloat($rootScope.DEFAULT_LATITUDE),
							lng: parseFloat($rootScope.DEFAULT_LONGITUDE)
						};
						try {
							locations.map.setCenter(centerlatlng);
						} catch (err) {
							console.log(err);
						}
					}, function () {
						setTimeout(function () {
							google.maps.event.trigger(locations.map, "resize");
							var centerlatlng = {
								lat: parseFloat($rootScope.DEFAULT_LATITUDE),
								lng: parseFloat($rootScope.DEFAULT_LONGITUDE)
							};
							try {
								locations.map.setCenter(centerlatlng);
							} catch (err) {
								console.log(err);
							}
						}, 100);
					});
				} else {
					setTimeout(function () {
						google.maps.event.trigger(locations.map, "resize");
						var centerlatlng = {
							lat: parseFloat($rootScope.DEFAULT_LATITUDE),
							lng: parseFloat($rootScope.DEFAULT_LONGITUDE)
						};
						try {
							locations.map.setCenter(centerlatlng);
						} catch (err) {
							console.log(err);
						}
					}, 100);
				} */
			}
		}


		function drawPolylineForGeoFence(latlngsToDraw, map, color, details, paths) {
			var spreadAssetCoordinates = [];
			$.each(latlngsToDraw, function (index, value) {

				spreadAssetCoordinates.push({
					lat: value.lat,
					lng: value.lng
				});
			});

			if (spreadAssetCoordinates.length > 0) {
				var midLatLng = {
					lat: spreadAssetCoordinates[spreadAssetCoordinates.length - 1].lat,
					lng: spreadAssetCoordinates[spreadAssetCoordinates.length - 1].lng
				};
				var infowindow = new google.maps.InfoWindow(
					{
						content: '<div class="infoWindowhead">'
							+ "name"
							+ '<div class="infoWindowContent"> <b>Description :</b> '
							+ "des" + '</div></div>'
					});

				infowindow.setPosition(midLatLng);
				var lineSymbol = {
					path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
					scale: 2,
				};
				var iconStyle = [{
					icon: lineSymbol,
					offset: '100%',
					repeat: '500px'
				}];

				var ColorValue = '#ff0000';
				if (color == "red") {
					ColorValue = '#ff0000';
				} else if (color == "black") {
					ColorValue = '#000000';
				} else if (color == "blue") {
					ColorValue = '#68A8DE';
				} else if (color == "green") {
					ColorValue = '#00e658';
				} else if (color == "orange") {
					ColorValue = '#fd7a24';
				} else if (color == "DarkBlue") {
					ColorValue = '#CA902E';
				} else {
					ColorValue = '#208000';
				}

				var polylinepath = null;
				var strokeOpacity = 1.0;
				if(paths!=null || paths!=undefined){
					strokeOpacity = paths.stroke.weight;
				}

				if (color == "blue") {
					polylinepath = new google.maps.Polyline({
						path: spreadAssetCoordinates,
						geodesic: true,
						strokeColor: ColorValue,
						strokeOpacity: strokeOpacity,
						strokeWeight: 3
					});
				} else {
					polylinepath = new google.maps.Polyline({
						path: spreadAssetCoordinates,
						geodesic: true,
						strokeColor: ColorValue,
						strokeOpacity: strokeOpacity,
						strokeWeight: 3,
						icons: iconStyle
					});
				}

				polylinepath.setOptions({
					strokeColor: ColorValue
				});

				google.maps.event.addListener(polylinepath, 'mouseout', function (event) {
					infowindow.close();
				});

				google.maps.event.addListener(polylinepath, 'mouseover', function (event) {
					if (openedInfoWindow != null) {
						openedInfoWindow.close();
					}
					infowindow.setContent('<div class="infoWindowhead">'
						+ '</br></br>' + details + '</br></div>'
					);

					infowindow.mousemove;
					infowindow.open(map);
					infowindow.setPosition(event.latLng);
					openedInfoWindow = infowindow;
				});
				polylinepath.setMap(map);
			}
		}

		vm.datePickerOpenStatus.createdDate = false;
		vm.datePickerOpenStatus.modifiedDate = false;
		vm.datePickerOpenStatus.serviceDate = false;

		function openCalendar(date) {
			vm.datePickerOpenStatus[date] = true;

		}

		$scope.reset = function () {
			vm.userGeofences = [];
			vm.assetFilterGeofences = [];
			vm.selectedUserGeofenceId = null;
			vm.prevSelectedUserGeofenceId = null;
			var cleratodatefromdate = vm.today();
			// cleratodatefromdate.remove();
		}

		function downloadLoadPath() {
			var data = {
				fromDate: vm.fromDate.getTime(),
				toDate: vm.toDate.getTime(),
				userId: vm.pathuserid,
				type: vm.type
			}
			LocationLogMapPath.downloadUserPath(data, function (response) {
				var a = document.createElement("a");
				a.style = "display: none";
				var file = new Blob([(response)], { type: 'application/text' });
				var fileURL = URL.createObjectURL(file);
				a.href = fileURL;
				a.download = "TravelledPath.kml";
				a.click();
				window.URL.revokeObjectURL(fileURL);
			});
		}

		function filterAssetsLocationOnMapView() {
			vm.allGeofences = []
			if (vm.adminFilter) {
				GeofenceIDs.getAll(function (response) {
					response.forEach(function (geofence) {
						if (geofence.name != 'Bangalore') {
							geofence.label = geofence.name.substring(0, 15) + "..";
							vm.allGeofences.push(geofence);
							if (vm.selectedGeofenceId == null) {
								vm.selectedGeofenceId = geofence.id;
							}
						}
					});
				});
			} else {
				UserGeofences.getAll(function (response) {
					response.forEach(function (geofence) {
						if (geofence.name != 'Bangalore') {
							geofence.label = geofence.name.substring(0, 15) + "..";
							vm.allGeofences.push(geofence);
							if (vm.selectedGeofenceId == null) {
								vm.selectedGeofenceId = geofence.id;
							}
						}
					});
				});
			}
			/* $("#mapFilterLocationModal").show();
			noDataText = document.getElementById("noData");
			noDataText.style.display = "none"; */
			vm.prevSelectedGeofenceId = vm.selectedGeofenceId;
		}

		function closeMapLocationFilterModal() {
			$("#mapFilterLocationModal").removeClass("in");
			$(".modal-backdrop").remove();
			$("#mapFilterLocationModal").hide();
			vm.selectedGeofenceId = vm.prevSelectedGeofenceId;
		}

		function filterAssetsLoadOnMapView() {
			$("#mapFilterLoadPathModal").show();
			noDataText = document.getElementById("noData");
			noDataText.style.display = "none";
			vm.prevSelectedUserGeofenceId = vm.selectedUserGeofenceId;
		}

		function closeMapLoadPathFilterModal() {
			$("#mapFilterLoadPathModal").removeClass("in");
			$(".modal-backdrop").remove();
			$("#mapFilterLoadPathModal").hide();
			vm.selectedUserGeofenceId = vm.prevSelectedUserGeofenceId;
		}
			$scope.onDateChange = function () {
            onChangeDate(vm.pathuserid);
            };

		function saveLoadPathFilter() {

			// onChangeDate(vm.pathuserid);

			vm.mapUserAssets = [];

			AssetTypesByGeofenceID.get(vm.selectedUserGeofenceId, function (assetTypeVal) {
				vm.assetTypeValuesPath = assetTypeVal;
				getGroupAssetsFromDBPath(vm.selectedUserGeofenceId, null, vm.mapUserAssets);
			});

			vm.prevSelectedUserGeofenceId = vm.selectedUserGeofenceId;
		}

		function clearMarkers(markersList) {
			for (var i = 0; i < markersList.length; i++) {
				markersList[i].setMap(null);
			}
		}

		function clearPolylines(polylinesList) {
			for (var i = 0; i < polylinesList.length; i++) {
				polylinesList[i].setMap(null);
			}
		}


		function saveLocationFilter() {
			vm.polygon.forEach(function(polygon){
				polygon.setMap(null);
			});
			vm.polygon = [];
			vm.mapAssets = [];
			AssetTypesByGeofenceID.get(vm.selectedGeofenceId, function (assetTypeVal) {
				vm.assetTypeValues = assetTypeVal;
				getGroupAssetsFromES(vm.selectedGeofenceId, null, vm.mapAssets);
			});

			vm.prevSelectedGeofenceId = vm.selectedGeofenceId;
			GeofenceByID.get(vm.selectedGeofenceId, function (geofenceDetails) {
				var path = JSON.parse(geofenceDetails.coordinates);
				var infowindow = new google.maps.InfoWindow({
					content:
						'<div class="infoWindowhead">' +
						"name" +
						'<div class="infoWindowContent"> <b>Description :</b> ' +
						"des" +
						"</div></div>",
				});

				if(path.length>0){
					infowindow.setPosition(path[0]);
				}
				var strokeColor = "#0066CC";

				var tempPolygon = new google.maps.Polygon({
					paths: path,
					strokeColor: strokeColor,
					strokeOpacity: 0.5,
					strokeWeight: 1.2,
					fillColor: strokeColor,
					fillOpacity: 0.1,
					zIndex:-1
				});			
				google.maps.event.addListener(
					tempPolygon,
					"click",
					function (event) {
						if (openedInfoWindow != null) {
							openedInfoWindow.close();
						}
						infowindow.setContent(
							'<div class="infoWindowhead">' +
							"<b>Geofence </b><br><br>" +
							geofenceDetails.name +
							"</br></div>"
						);

						infowindow.mousemove;
						infowindow.open(locations.map);
						infowindow.setPosition(event.latLng);
						openedInfoWindow = infowindow;

						//geoLocation(locationsCity.mapCity)
					}
            );
				tempPolygon.setMap(locations.map);
				vm.polygon.push(tempPolygon);																				
			});
			$("#mapFilterLocationModal").removeClass("in");
			$(".modal-backdrop").remove();
			$("#mapFilterLocationModal").hide();
		}

		function drawPolyline(spread, map) {

			var spreadAssetCoordinates = [];
			var spreadColor = 0;
			var spreadWidth = 0;
			var spreadOpacity = 0;

			vm.assetTypes.forEach(function (assetType) {
				if (assetType.name == spread.assetTypeName) {
					spreadColor = assetType.colorcode;
					spreadWidth = assetType.lineWidth * 0.05;
					spreadOpacity = assetType.transparency * 0.01;
				}
			});
			$.each(spread.assetCoordinates, function (index, value) {

				spreadAssetCoordinates.push({
					lat: value.latitude,
					lng: value.longitude
				});
			});
			if (spreadAssetCoordinates.length > 1) {
				var midLatLng = {
					lat: spread.assetCoordinates[spread.assetCoordinates.length - 1].latitude,
					lng: spread.assetCoordinates[spread.assetCoordinates.length - 1].longitude
				};

				var polylineColor = '';
				var distanceFromPOP = '';
				var fiberCoreVal = '';
				var infowindow = null;
				if (spread.assetTypeLayout == "SPREAD") {
					polylineColor = spreadColor;
				}
				var polylineWeight = spreadWidth;
				var strokeOpacityVal = spreadOpacity;

				var polylinepath = new google.maps.Polyline({
					path: spreadAssetCoordinates,
					geodesic: true,
					strokeColor: polylineColor,
					strokeOpacity: strokeOpacityVal,
					strokeWeight: polylineWeight,
					fillColor: polylineColor,
					fillOpacity: 0.3,
					editable: false,
				});

				google.maps.event.addListener(polylinepath, 'click', function (event) {
					if (openedInfoWindow != null) {
						openedInfoWindow.close();
					}
					var disVal = 0;
					var cLocations = [];

					if (spread.description == null || spread.description == undefined) {
						spread.description = "";
					}

					if (spread.assetTypeLayout == "SPREAD") {
						AssetByID.get(spread.id, function (assetVal) {
							spread = assetVal;
							var infoStr = "";
							var assetTypeAttributeValuesList = spread.assetTypeAttributeValues;
							assetTypeAttributeValuesList.sort(function (a, b) {
								var nameA = a.assetTypeAttribute.name.toLowerCase(),
									nameB = b.assetTypeAttribute.name.toLowerCase()
								if (nameA < nameB) // sort string ascending
									return -1
								if (nameA > nameB)
									return 1
								return 0 // default return value (no sorting)
							});
							for (var i = 0; i < assetTypeAttributeValuesList.length; i++) {
								var home = assetTypeAttributeValuesList[i];

								var attrVal = "";
								if (home.attributeValue != null) {
									attrVal = home.attributeValue;
								}
								infoStr += '<br><b>' +
									home.assetTypeAttribute.name +
									'</b> : ' +
									attrVal;
							}
							var spreadCoordinates = spread.assetCoordinates;
							if (spreadCoordinates.length > 0) {
								for (var index in spreadCoordinates) {
									if (index > 0) {
										disVal += distanceCal(spreadCoordinates[index].latitude, spreadCoordinates[index].longitude, spreadCoordinates[index - 1].latitude, spreadCoordinates[index - 1].longitude);
									}
								}
							}

							var userContent = document.createElement('div');

							userContent.innerHTML = '<div class="infoWindowhead">' +
								'<b>Name : </b> ' + spread.name + "<br><b>Asset Type : </b> " + spread.assetType.name + '</br>' +
								'<b>Distance : </b> ' + (parseFloat(disVal)).toFixed(2) + ' Km</br>';

							infowindow = new google.maps.InfoWindow({
								content: userContent
							});
						});
					}
					if (infowindow != null) {
						infowindow.setPosition(event.latLng);
						infowindow.open(map);
						openedInfoWindow = infowindow;
					}
				});

				polylinepath.setMap(map);

				polylines.push(polylinepath);
			}
		}


		function distanceCal(lat1, lon1, lat2, lon2) {
			var theta = lon1 - lon2;
			var dist = Math.sin(degrees_to_radians(lat1)) * Math.sin(degrees_to_radians(lat2)) +
				Math.cos(degrees_to_radians(lat1)) * Math.cos(degrees_to_radians(lat2)) * Math.cos(degrees_to_radians(theta));
			dist = Math.acos(dist);
			dist = radians_to_degrees(dist);
			dist = dist * 60 * 1.1515;
			dist = dist * 1.609344;
			if (isNaN(dist)) {
				return 0.0;
			} else {
				return (dist);
			}
		}

		function degrees_to_radians(degrees) {
			var pi = Math.PI;
			return degrees * (pi / 180);
		}

		function radians_to_degrees(radians) {
			var pi = Math.PI;
			return radians * (180 / pi);
		}
			vm.geofenceCaseMarkers = [];
			vm.showGeofenceCases = true;

			function clearGeofenceCaseMarkers() {
				for (var i = 0; i < vm.geofenceCaseMarkers.length; i++) {
					vm.geofenceCaseMarkers[i].setMap(null);
				}
				vm.geofenceCaseMarkers = [];
			}

				vm.displayGeofenceCases=function(geofenceId){
					clearGeofenceCaseMarkers();
					var sendData={
						geofenceId: geofenceId,
					}
						TrCaseForMap.getAllCases(
							sendData,
							function (response) {
								vm.geofenceCaseResponse = response
						drawLatestTrCases(vm.geofenceCaseResponse)
							}
				)
				}
function clearGeofenceMarkers() {
    vm.geofenceMarkers.forEach(function (m) {
        m.setMap(null);
    });
    vm.geofenceMarkers = [];
}

vm.displayGeofenceCasesInLOadTravel = function (geofenceId) {
    clearGeofenceMarkers();

    TrCaseForMap.getAllCases({ geofenceId: geofenceId }, function (response) {
        drawLatestTrCasesOnTravel(response);
    });
};

				function drawLatestTrCases(data){
					data.forEach(function(value){
                    var startMarker = new google.maps.Marker({
                            map: locations.map,
                            position: new google.maps.LatLng(
                                value.pinLat,
                                value.pinLong
                            ),
                            title: value.description,
                        });
						vm.geofenceCaseMarkers.push(startMarker);
						var userContent = document.createElement("div"),
                            button;

                        var infoWindow = new google.maps.InfoWindow({
                            content: userContent,
                        });
                        var infoWindow2 = new google.maps.InfoWindow();
                        // if(value.userCase=='C'){
                        if(value.status=='RESOLVED' || value.status=='CLOSED' || value.status=='CANCELLED'){
                                 startMarker.setIcon(
                                    "content/images/Pointers-L5.png"
                                );
                                startMarker.setZIndex(10);
                        } else {
                            startMarker.setZIndex(11);
                            if (value.priority == "LOW") {
                                startMarker.setIcon(
                                    "content/images/Pointers-L4.png"
                                );
                            } else if (value.priority == "MEDIUM") {
                                startMarker.setIcon(
                                    "content/images/Pointers-M4.png"
                                );
                            } else if (value.priority == "HIGH") {
                                startMarker.setIcon(
                                    "content/images/Pointers-H4.png"
                                );
                            } else if (value.priority == "CRITICAL") {
                                startMarker.setIcon(
                                    "content/images/Pointer-C4.png"
                                );
                            }
                        }
						userContent.innerHTML =
                            '<div class="infoWindowhead">' +
                            startMarker.title +
                            '</div><div class="infoWindowContent"> <b>Incident Id : </b>' +
                            value.id +
                            "<br> <b>Reported By :</b> " +
                            value.reportedByUser +
                            "<br> <b> Assigned To :</b> " +
                            value.assignedToUser +
                            "<br> <b> Status :</b> " +
                            value.status +                            
                            "</div>";
							button = userContent.appendChild(
                            document.createElement("input")
                        );
                        button.type = "button";
                        button.value = "Incident Details";
                        button.className = "button";

                        google.maps.event.addDomListener(
                            button,
                            "click",
                            function () {
                                $state.go("tr-case-detail", {
                                    id: value.id,
                                });
                            }
                        );
                        $compile(userContent)($scope);
                        google.maps.event.addListener(
                            startMarker,
                            "click",
                            function () {
                                // infoWindow.setContent('<div class="infoWindowhead">' + startMarker.title + '</div>' + userContent);
                                // infoWindow.open(locations.map, startMarker);
                                TrCaseById.get(value.id, function (response) {

                                     var infoStr = "";
                                    var caseTypeAttributeValuesList =
                                        response.caseTypeAttributeValues;
                                    caseTypeAttributeValuesList.sort(function (a, b) {
                                        var nameA = a.caseTypeAttribute.name.toLowerCase(),
                                            nameB = a.caseTypeAttribute.name.toLowerCase();
                                        if (nameA < nameB)
                                            // sort string ascending
                                            return -1;
                                        if (nameA > nameB) return 1;
                                        return 0; // default return value (no sorting)
                                    });
                                    for (
                                        var i = 0;
                                        i < caseTypeAttributeValuesList.length;
                                        i++
                                    ) {
                                        var home = caseTypeAttributeValuesList[i];
                                        infoStr +=
                                            "<br><b>" +
                                            home.caseTypeAttribute.name +
                                            "</b> : " +
                                            home.attributeValue;
                                    }

                                    userContent.innerHTML =
                                        '<div class="infoWindowhead">' +
                                        response.description +
                                        '</div><div class="infoWindowContent"> <b>Incident Id : </b>' +
                                        value.id +
                                        "<br><b>Description : </b>" +
                                        response.description +
                                        "<br><b>Incident Type : </b>" +
                                        response.caseType.name +
                                        "<br> <b>Reported By :</b> " +
                                        response.reportedByUser +
                                        "<br> <b> Assigned To :</b> " +
                                        response.assignedToUser +
                                        "<br> <b> Status :</b> " +
                                        response.status +                                        
                                        "<br> " +
                                        infoStr +
                                        "</div>";
										infoWindow = new google.maps.InfoWindow({
                                        content: userContent,
                                    });
                                    infoWindow.open(locations.map, startMarker);
                            
                                });
							})
							})
						}
						vm.geofenceMarkers=[]
			function drawLatestTrCasesOnTravel(data){
					data.forEach(function(value){
                    var startMarker = new google.maps.Marker({
                            map: userPaths.map,
                            position: new google.maps.LatLng(
                                value.pinLat,
                                value.pinLong
                            ),
                            title: value.description,
                        });
						vm.geofenceMarkers.push(startMarker);
						var userContent = document.createElement("div"),
                            button;

                        var infoWindow = new google.maps.InfoWindow({
                            content: userContent,
                        });
                        var infoWindow2 = new google.maps.InfoWindow();
                        // if(value.userCase=='C'){
                        if(value.status=='RESOLVED' || value.status=='CLOSED' || value.status=='CANCELLED'){
                                 startMarker.setIcon(
                                    "content/images/Pointers-L5.png"
                                );
                                startMarker.setZIndex(10);
                        } else {
                            startMarker.setZIndex(11);
                            if (value.priority == "LOW") {
                                startMarker.setIcon(
                                    "content/images/Pointers-L4.png"
                                );
                            } else if (value.priority == "MEDIUM") {
                                startMarker.setIcon(
                                    "content/images/Pointers-M4.png"
                                );
                            } else if (value.priority == "HIGH") {
                                startMarker.setIcon(
                                    "content/images/Pointers-H4.png"
                                );
                            } else if (value.priority == "CRITICAL") {
                                startMarker.setIcon(
                                    "content/images/Pointer-C4.png"
                                );
                            }
                        }
						userContent.innerHTML =
                            '<div class="infoWindowhead">' +
                            startMarker.title +
                            '</div><div class="infoWindowContent"> <b>Incident Id : </b>' +
                            value.id +
                            "<br> <b>Reported By :</b> " +
                            value.reportedByUser +
                            "<br> <b> Assigned To :</b> " +
                            value.assignedToUser +
                            "<br> <b> Status :</b> " +
                            value.status +                            
                            "</div>";
							button = userContent.appendChild(
                            document.createElement("input")
                        );
                        button.type = "button";
                        button.value = "Incident Details";
                        button.className = "button";

                        google.maps.event.addDomListener(
                            button,
                            "click",
                            function () {
                                $state.go("tr-case-detail", {
                                    id: value.id,
                                });
                            }
                        );
                        $compile(userContent)($scope);
                        google.maps.event.addListener(
                            startMarker,
                            "click",
                            function () {
                                // infoWindow.setContent('<div class="infoWindowhead">' + startMarker.title + '</div>' + userContent);
                                // infoWindow.open(locations.map, startMarker);
                                TrCaseById.get(value.id, function (response) {

                                     var infoStr = "";
                                    var caseTypeAttributeValuesList =
                                        response.caseTypeAttributeValues;
                                    caseTypeAttributeValuesList.sort(function (a, b) {
                                        var nameA = a.caseTypeAttribute.name.toLowerCase(),
                                            nameB = a.caseTypeAttribute.name.toLowerCase();
                                        if (nameA < nameB)
                                            // sort string ascending
                                            return -1;
                                        if (nameA > nameB) return 1;
                                        return 0; // default return value (no sorting)
                                    });
                                    for (
                                        var i = 0;
                                        i < caseTypeAttributeValuesList.length;
                                        i++
                                    ) {
                                        var home = caseTypeAttributeValuesList[i];
                                        infoStr +=
                                            "<br><b>" +
                                            home.caseTypeAttribute.name +
                                            "</b> : " +
                                            home.attributeValue;
                                    }

                                    userContent.innerHTML =
                                        '<div class="infoWindowhead">' +
                                        response.description +
                                        '</div><div class="infoWindowContent"> <b>Incident Id : </b>' +
                                        value.id +
                                        "<br><b>Description : </b>" +
                                        response.description +
                                        "<br><b>Incident Type : </b>" +
                                        response.caseType.name +
                                        "<br> <b>Reported By :</b> " +
                                        response.reportedByUser +
                                        "<br> <b> Assigned To :</b> " +
                                        response.assignedToUser +
                                        "<br> <b> Status :</b> " +
                                        response.status +                                        
                                        "<br> " +
                                        infoStr +
                                        "</div>";
										infoWindow = new google.maps.InfoWindow({
                                        content: userContent,
                                    });
                                    infoWindow.open(userPaths.map, startMarker);
                            
                                });
							})
							})
						}
						vm.toggleGeofenceCaseMarkers = function () {
						for (var i = 0; i < vm.geofenceCaseMarkers.length; i++) {
						vm.geofenceCaseMarkers[i].setMap(
							vm.showGeofenceCases ? locations.map : null
						);
							}
						};

	}
})();